'use strict';

var checkout = angular.module('gymsystem.checkout', []);

checkout.controller('CheckoutCtrl', ['$rootScope', '$scope', '$controller', '$filter', '$modal', '$routeParams', '$location', 'server', 'paymentMethods', 'alertProvider', 'cashiers', 'payment', 'confirm', 'formatter', '$q', 'modalUtils', '$timeout', 'util', 'stripe', 'pubsub', function($rootScope, $scope, $controller, $filter, $modal, $routeParams, $location, server, paymentMethods, alertProvider, cashiers, $payment, confirm, formatter, $q, modalUtils, $timeout, util, stripe, pubsub) {
    $scope.checkoutInitialized = false;
    $rootScope.waitFor(['paymentmethods', 'cashregisters']).then(function() {
        $scope.checkoutInitialized = true;
        $scope.loadingStatus = {};
        $scope.search = {};
        $scope.checkoutForm = {
            elForm: null,
            elHeader: null,
            elList: null,
            allSelectedForRefund: false,
        };
        var paymentMethodOptions = {checkout: true, refund: false };
        var receipttypes = {
            printer: { id: 'printer', name: 'Printer' },
            mail: { id: 'mail', name: 'E-mail' },
            sms: { id: 'sms', name: 'SMS' },
            trash: { id: 'trash', name: 'Throw receipt' }
        };
        var receiptoptions = [];
        var economyConfig;

        var addPayment = function(payment) {
            if (_.findWhere($scope.basket, {payment: payment.id})) {
                return;
            }

            var product = {id: payment.cardtype_id, name: payment.name };
            var item  = {
                product: product,
                count: 1,
                price: Number(payment.amount) + Number(payment.discount || 0),
                payment: payment.id,
                paymentStatus: payment.status,
                selectedForRefund: false,
                trainingcard_id: payment.trainingcard_id || null,
                parent_trainingcard_id: payment.parent_trainingcard_id || null
            };
            $scope.basket.push(item);

            (payment.discounts || []).forEach(d => {
                let discount = {
                    discount_percent: 0,
                    id: d.id,
                    name: _.findWhere($rootScope.trainingcardtypes, {id: d.id}).name,
                    discount: true
                };
                $scope.addDiscount(discount, Number(d.amount), payment.id);
            })
            $scope.updateEconomyTables();
            $scope.recalculateBasket();
        };

        var updateReadonlyFields = function(readonly) {
            _.findWhere($scope.fields, {name: 'customer'}).readonly = readonly;
            _.findWhere($scope.fields, {name: 'method'}).readonly = readonly;
            _.findWhere($scope.fields, {name: 'externalReference'}).readonly = readonly;
        }

        $scope.paymentsAddedfromExternalPayment = function() {
            if (!$scope.fields) return false;
            var externalReferenceField = _.findWhere($scope.fields, {name: 'externalReference'})
            return externalReferenceField && externalReferenceField.value && externalReferenceField.readonly;
        }

        var addPaymentsFromReceipt = function(pspReference) {
            return server.get('/api/payment/get_from_external_reference', {external_reference: pspReference}).then(function(payments) {
                if (payments?.length) {
                    $scope.reset();
                    $scope.purchase = false;

                    const payerId = payments[0].payer_id;
                    if (payerId) {
                        _.findWhere($scope.fields, {name: 'customer'}).value = $rootScope.getMember(payerId);
                    }

                    payments.forEach(payment => addPayment(payment));

                    // Build package groups: identify parent/child relationships via parent_trainingcard_id
                    var parentTrainingcardIds = new Set();
                    $scope.basket.forEach(function(item) {
                        if (item.parent_trainingcard_id) {
                            parentTrainingcardIds.add(item.parent_trainingcard_id);
                        }
                    });
                    $scope.basket.forEach(function(item) {
                        if (item.parent_trainingcard_id) {
                            item.isPackageMember = true;
                            item.packageGroupId = item.parent_trainingcard_id;
                        } else if (parentTrainingcardIds.has(item.trainingcard_id)) {
                            item.isPackageMember = true;
                            item.packageGroupId = item.trainingcard_id;
                        }
                    });
                    // Copy parent product name as packageName on all group members
                    $scope.basket.forEach(function(item) {
                        if (item.isPackageMember) {
                            var parent = _.find($scope.basket, function(b) {
                                return b.trainingcard_id === item.packageGroupId;
                            });
                            if (parent) {
                                item.packageName = parent.product.name;
                            }
                        }
                    });

                    // Sort basket: package children after parent, discounts after their payment, credited items last
                    var uncredited = $scope.basket.filter(function(item) { return item.paymentStatus !== 'credited'; });
                    var credited = $scope.basket.filter(function(item) { return item.paymentStatus === 'credited'; });
                    var sorted = [];
                    var added = new Set();

                    var addWithDiscounts = function(item) {
                        sorted.push(item);
                        added.add(item);
                        // Pull in discounts for this payment
                        uncredited.forEach(function(d) {
                            if (!added.has(d) && d.discount_for_payment_id && d.discount_for_payment_id === item.payment) {
                                sorted.push(d);
                                added.add(d);
                            }
                        });
                    }

                    uncredited.forEach(function(item) {
                        if (added.has(item)) return;
                        if (item.parent_trainingcard_id) return; // skip children — pulled in by parent
                        if (item.discount_for_payment_id) return; // skip discounts — pulled in by their payment
                        addWithDiscounts(item);
                        if (item.isPackageMember) {
                            uncredited.forEach(function(child) {
                                if (!added.has(child) && child.packageGroupId === item.packageGroupId && child.parent_trainingcard_id) {
                                    addWithDiscounts(child);
                                }
                            });
                        }
                    });
                    // Add any remaining items (orphan children, unlinked discounts)
                    uncredited.forEach(function(item) {
                        if (!added.has(item)) {
                            sorted.push(item);
                        }
                    });
                    $scope.basket = sorted.concat(credited);

                    let methodField = _.findWhere($scope.fields, {name: 'method'});
                    if (methodField.value !=  _.findWhere($rootScope.paymentmethods, {id: payments[0].method})) {
                        alertProvider.show('success', 'Payment method changed', null, 1750);
                    }
                    methodField.value = _.findWhere($rootScope.paymentmethods, {id: payments[0].method});
                    _.findWhere($scope.fields, {name: 'externalReference'}).value = pspReference;
                    updateReadonlyFields(true);
                    alertProvider.show('success', 'Payment added', null, 1000);
                } else {
                    alertProvider.show('error', 'Did not find any payments with the given PSP-Reference', null, 1000);
                }
            });
        }

        var toggleDiscountsForRefundItem = function(item) {
            angular.forEach($scope.basket, function(basketItem) {
                // Only toggle discounts associated with the non-credited payment item
                if (basketItem.product.discount && basketItem.discount_for_payment_id === item.payment) {
                    basketItem.selectedForRefund = item.selectedForRefund;
                }
            });
        };

        $scope.toggleAllAdyenRefundOptions = function() {
            // Toggle selection for all non-credited payments
            angular.forEach($scope.basket, function(item) {
                if (item.paymentStatus !== 'credited' && item.payment) {
                    item.selectedForRefund = $scope.checkoutForm.allSelectedForRefund;
                    toggleDiscountsForRefundItem(item);
                }
            });
        };

        $scope.toggleSingleAdyenRefundOption = function(item) {
            if (item.isPackageMember) {
                // Toggle all items in the same package group together
                angular.forEach($scope.basket, function(basketItem) {
                    if (basketItem.packageGroupId === item.packageGroupId && basketItem.paymentStatus !== 'credited') {
                        basketItem.selectedForRefund = item.selectedForRefund;
                        toggleDiscountsForRefundItem(basketItem);
                    }
                });
            } else {
                toggleDiscountsForRefundItem(item);
            }

            // Update "Select All" based on individual selections
            $scope.checkoutForm.allSelectedForRefund = $scope.basket
                .filter(item => item.paymentStatus !== 'credited' && item.payment)
                .every(validItem => validItem.selectedForRefund);
        };

        $rootScope.listeningForInput = true;
        $rootScope.setupKeypressListener(10);

        $scope.$on('$destroy', function() {
            $rootScope.listeningForInput = false;
        });

        var keypress = '';
        var idleTimer = null;

        $scope.$on('keypress', function(onEvent, keypressEvent) {
            if (!modalUtils.modalsExist() && $rootScope.listeningForInput) {
                $timeout.cancel(idleTimer);
                idleTimer = $timeout(function() {
                    keypress = '';
                }, 2000);
                if (keypressEvent.keyCode == 13 || keypressEvent.keyCode == 9) {
                    var success = false;
                    if (keypress.length) {
                        if($scope.purchase) {
                            $scope.getBuyableTrainingCards().concat($scope.getBuyableProducts()).forEach(function(product) {
                                // The top-level barcode only means anything for a single-variant (or
                                // variant-less) product — with 2+ variants it can be a stale value
                                // left over from before the extra variants existed, which must not
                                // be trusted to identify this product.
                                var variants = product.variants || [];
                                if (variants.length <= 1 && product.barcode == keypress) {
                                    $scope.addProduct(product);
                                    success = true;
                                    if (!product.needs_to_choose_variant()) {
                                        alertProvider.show('success', product.name, null, 1000);
                                    }
                                } else {
                                    var variant = variants.find(function(variant) { return variant.barcode == keypress; });
                                    if (variant) {
                                        $scope.addProduct(product, variant.name);
                                        success = true;
                                    }
                                }
                            });
                            if (!success) {
                                alertProvider.show('error', $filter('translate')('Product does not exist'), null, 1000);
                            }
                        } else {
                            addPaymentsFromReceipt(keypress);
                        }
                        keypress = '';
                    }
                } else {
                    var charCode = (typeof keypressEvent.which == "number") ? keypressEvent.which : keypressEvent.keyCode;
                    keypress += String.fromCharCode(charCode);
                }
            }
        });

        $scope.resetForm = function(scope) {
            for (var i=0; i < $scope.fields.length; ++i) {
                var field = $scope.fields[i];
                if (field.name != 'cashier') {
                    delete field.value;
                }
            }

            for(var cs = scope.$$childHead; cs; cs = cs.$$nextSibling) {
                if (cs.form) {
                    cs.form.$setPristine();
                }
                $scope.resetForm(cs);
            }

            if ($scope.setInitialValues) {
                $scope.setInitialValues();
            }
        };

        function getDefaultMethod(repurchase) {
            if ($scope.selfCheckout) { return; }
            var test = [];
            var methodId = $scope.getCashier() && $scope.getCashier().method;
            if (methodId) {
                test.push(methodId);
            }
            test.push('cash');

            var methods = paymentMethods.getCheckout();
            if (repurchase) {
                methods = methods.filter(function(m) { return m.refund; });
            }

            for (var i=0; i < test.length; ++i) {
                var m =_.findWhere(methods, {id: test[i]});
                if (m) {
                    return m;
                }
            }
        }

        function noValueCard(pm) {
            return pm.id != 'valuecard';
        }

        function isUnderage() {
            var customer = $scope.getCustomer();
            if (!customer) { return false; }
            if (!customer.personalCodeNumber) { return true; }
            else {
                var age = util.getAgeFromPersonalCodeNumber(customer.personalCodeNumber);
                if (age <= 18) {
                    if (age < 16) { return true; }
                    if (!customer.allowInvoiceAt16) { return true; }
                }
            }
            return false;
        }

        function invoiceAgeRestriction(pm) {
            if (pm.id == 'invoice') {
                var customer = $scope.getCustomer();
                if (!customer) { return true; }
                return !isUnderage();
            }
            return true;
        }

        $scope.reset = function(repurchase) {
            $scope.resetForm($scope);
            _.findWhere($scope.fields, {name: 'method'}).value = getDefaultMethod(repurchase);
            _.findWhere($scope.fields, {name: 'seller'}).value = $rootScope.currentStaff;
            $scope.basket = [];
            $scope.search = {};
            $scope.purchase = !repurchase;
            if ($scope.stripeData) { $scope.stripeData = {}; }
            paymentMethodOptions.refund = !$scope.purchase;

            if ($scope.purchase) {
                paymentMethodOptions.filter = function(pm) {
                    const terminalHandler = $scope.getCashier()?.terminal_handler;
                    if (pm.id == 'xcard' && terminalHandler == 'adyen') return false;
                    if (pm.id == 'adyen-terminal' && terminalHandler == 'bambora') return false;
                    return noValueCard(pm) && invoiceAgeRestriction(pm);
                };
            } else {
                paymentMethodOptions.filter = function(pm) {
                    const terminalHandler = $scope.getCashier()?.terminal_handler;
                    if (pm.id == 'xcard' && terminalHandler == 'adyen') return false;
                    if (pm.id == 'adyen-terminal' && terminalHandler == 'bambora') return false;
                    return true;
                };
            }
            $scope.updateReceiptOptions();
            updateReadonlyFields(false);
            $scope.checkoutForm.allSelectedForRefund = false;
        };

        var customerChange = function() {
            if (!$scope.purchase) { return false; }
            var method = $scope.getMethod();
            if (method && method.id == 'invoice' && isUnderage()) {
                _.findWhere($scope.fields, { name: 'method' }).value = null;
            }
            $scope.recalculateBasket();
        };

        $scope.getTitle = function(name) {
            return (name && _.findWhere($scope.fields, {name: $rootScope.getRealFormName(name)}).title) || 'Cashier';
        };

        $scope.getCustomer = function() {
            return _.findWhere($scope.fields, {name: 'customer'}).value;
        };

        $scope.getSeller = function() {
            return _.findWhere($scope.fields, {name: 'seller'}).value;
        };

        $scope.getMethod = function() {
            return _.findWhere($scope.fields, {name: 'method'}).value;
        };

        $scope.getCashier = function() {
            return _.findWhere($scope.fields, {name: 'cashier'}).value;
        };

        $scope.closeCashier = function() {
            cashiers.close($scope.getCashier());
            $scope.reset();
        };

        $scope.getZReport = function() {
            $modal.open({
                templateUrl: 'views/addmodal.html',
                resolve: {
                    cashier: $scope.getCashier,
                },
                controller: ['$scope', '$controller', 'server', 'alertProvider', 'util', 'cashier', function($scope, $controller, server, alertProvider, util, cashier) {
                    $controller('AddCtrl', { $scope: $scope });

                    $scope.title = 'Get Z-report';
                    $scope.getButtonText = function() {
                        return 'Get report';
                    };

                    $scope.submit = function() {
                        $scope.loadingStatus.loading = true;

                        var item = $scope.getSubmitItem();
                        item.cashregister = cashier.id;

                        server.get('/api/checkout/report/get/z', item, null, {responseType: 'blob'}).then(function(data) {
                            if(data.size === 0) {
                                alertProvider.show('error', 'No reports found within the selected period');
                            } else {
                                var ext = data.type == 'application/zip' ? 'zip' : 'pdf';
                                util.download('Z-dagrapport.' + ext, null, null, data);
                                $scope.$close();
                            }
                            $scope.loadingStatus.loading = false;
                        });
                    };

                    $scope.fields = [
                        { name: 'fromDate', title: 'From', type: 'date', required: true, value: new Date().addDays(-1) },
                        { name: 'toDate', title: 'To', type: 'date', required: true, value: new Date() }
                    ];
                }]
            });
        };

        $scope.getReceiptMethods = function() {
            return _.findWhere($scope.fields, {name: 'receipt'}).value.id;
        };

        $scope.getPhone = function() {
            return _.findWhere($scope.fields, {name: 'phone'}).value;
        };

        $scope.recalculateBasket = function() {
            var giftcards = $scope.basket.filter(function(item) {
                return item.giftcard;
            });
            var valuecard = $scope.basket.filter(function(item) {
                return item.valuecard;
            });

            var discounts = $scope.basket.filter(function(item) {
                return item.product && item.product.discount;
            });

            // Remove legacy discounts and price-rule auto-discounts for recalculation
            $scope.basket = $scope.basket.filter(function(item) {
                return !item.giftcard && !item.valuecard && (!item.product || !item.product.discount) && !item.price_rule_discount;
            });

            discounts.forEach(function(item) {
                if (item.discount_for_payment_id) {
                    $scope.basket.push(item);
                } else {
                    $scope.addDiscount(item.product, item.discount_amount);
                }
            });

            if (valuecard.length) {
                $scope.addValueCardToShoppingCart();
            }

            giftcards.forEach(function(item) {
                $scope.addGiftCard(item.giftcard);
            });

            _.findWhere($scope.fields, {name: 'method'}).required = !!$scope.getTotalAmount();

            // Evaluate price rules for the current basket
            $scope.evaluatePriceRules();
        };

        $scope._priceRuleCode = null;

        $scope.evaluatePriceRules = function() {
            if (!$rootScope.hasFlag || !$rootScope.hasFlag('flag-price-rule-engine')) {
                return;
            }

            // `feeFor` marks a one-time fee line, which the server sends as
            // is_onetime_fee and keeps out of the engine basket. Pricing it here
            // would make this checkout report a rule the server never applies,
            // and since the rule set is what the two compare, the sale would be
            // refused and re-priced to the same mismatch every time.
            var productItems = $scope.basket.filter(function(item) {
                return item.product && !item.product.discount && !item.giftcard && !item.valuecard && !item.price_rule_discount && !item.feeFor;
            });

            if (!productItems.length) {
                return;
            }

            var engineItems = productItems.map(function(item) {
                return {
                    product_id: item.product.id,
                    count: item.count || 1,
                    price: item.price
                };
            });

            var customer = $scope.getCustomer();
            var data = {
                items: engineItems,
                customer_id: customer ? customer.id : null,
                site_id: ($rootScope.selectedSite && $rootScope.selectedSite.id) || null,
                discount_code: $scope._priceRuleCode || null
            };

            server.post('/api/checkout/pricerule/evaluate', data).then(function(response) {
                if (!response || !response.success) {
                    alertProvider.show('error', $filter('translate')('Failed to calculate discount'));
                    return;
                }
                var result = response.data;
                if (!result || !result.items) return;

                // Remove any existing price-rule auto-discount items
                $scope.basket = $scope.basket.filter(function(item) {
                    return !item.price_rule_discount;
                });

                // Add line-level discounts
                result.items.forEach(function(engineItem) {
                    (engineItem.applied_rules || []).forEach(function(rule) {
                        if (rule.discount_amount > 0) {
                            $scope.basket.push({
                                product: {id: rule.rule_id, name: rule.name, discount: false, price_rule: true},
                                count: 1,
                                price: -rule.discount_amount,
                                price_rule_discount: true,
                                extratext: rule.name
                            });
                        }
                    });
                });

                // Add order-level discounts
                (result.order_discounts || []).forEach(function(rule) {
                    if (rule.discount_amount > 0) {
                        $scope.basket.push({
                            product: {id: rule.rule_id, name: rule.name, discount: false, price_rule: true},
                            count: 1,
                            price: -rule.discount_amount,
                            price_rule_discount: true,
                            extratext: rule.name
                        });
                    }
                });

                $scope.$apply();
            });
        };

        $scope.addDiscount = function(discount, amount, discount_for_payment_id) {
            var discounts = $scope.basket.filter(function(item) {
                return item.product.discount && item.product.id == discount.id && (!discount_for_payment_id || discount_for_payment_id == item.payment);
            });
            if (discounts.length) {
                return;
            }

            var discount_amount = $scope.applyDiscount(discount, amount, discount_for_payment_id);

            var extratext = '';
            if (discount.discount_percent) {
                extratext += discount.discount_percent + ' %';
            }
            if (discount.discount_fixed > 0) {
                extratext += (extratext.length ? ', ' : '') + formatter.format('price', discount.discount_fixed);
            }
            var item = {product: discount, count: 1, price: -discount_amount, extratext: extratext, discount_for_payment_id, discount_amount: amount };
            $scope.basket.push(item);
        };

        $scope.addGiftCard = function(giftcard) {
            var giftcards = $scope.basket.filter(function(item) {
                return item.giftcard && item.giftcard.id == giftcard.id;
            });
            if (giftcards.length) {
                return;
            }

            var total = $scope.getTotalAmount();
            var price = giftcard.amount;
            var fromGiftCard = Math.min(total, price);
            var left = Math.max(price - total, 0);
            var extratext = $filter('translate')('{0} left after purchase').format(formatter.format('price', left)) + ' ' + util.t('Code') + ': ' + giftcard.code;
            var product = {id: giftcard.product_id, name: giftcard.name};

            var item = {product: product, count: 1, price: -fromGiftCard, giftcard: giftcard, extratext: extratext };
            $scope.basket.push(item);
        };

        $scope.addGiftCardToShoppingCart = function() {
            $modal.open({
                templateUrl: '/views/giftcard.html',
                controller: 'GiftCardModalCtrl'
            }).result.then($scope.addGiftCard);
        };

        $scope.addDiscountToShoppingCart = function() {
            $modal.open({
                templateUrl: '/views/discount.html',
                controller: 'DiscountModalCtrl',
                resolve: {
                    customer: function() { return $scope.getCustomer(); }
                }
            }).result.then(function(result) {
                if (result.price_rule_code) {
                    // Price-rule code: store code and re-evaluate
                    $scope._priceRuleCode = result.price_rule_code;
                    $scope.recalculateBasket();
                } else {
                    $scope.addDiscount(result.discount, result.amount);
                }
            });
        };

        $scope.addValueCardToShoppingCart = function() {
            var amount = $scope.getCustomer().getValueCardAmountForSelectedLegalEntity();
            var total = $scope.getTotalAmount();
            var fromValueCard = Math.min(total, amount);
            var left = Math.max(amount - total, 0);
            var extratext = $filter('translate')('{0} left after purchase').format(formatter.format('price', left));
            var product = {id: $rootScope.getActiveProducts().filter(function(p) { return p.valuecard; })[0].id, name: $filter('translate')('Value card')};

            var item = {product: product, count: 1, price: -fromValueCard, valuecard: true, extratext: extratext };
            $scope.basket.push(item);
        };

        $scope.valueCardLinkClicked = function() {
            if ($scope.purchase) {
                $scope.addValueCardToShoppingCart();
                $scope.recalculateBasket();
            } else {
                var valuecard = _.findWhere($rootScope.getActiveProducts(), {valuecard: true});
                $scope.basket = [{product: valuecard, count: 1, payWhatYouWant: true, price: $scope.getCustomer().getValueCardAmountForSelectedLegalEntity() }];
            }
        };

        $scope.hasValueCardInBasket = function() {
            return $scope.basket.filter(function(item) {
                return item.valuecard;
            }).length > 0;
        };

        $scope.showValueCardLink = function() {
            if (!$scope.getCustomer()) {
                return false;
            }

            if ($scope.purchase) {
                return $scope.getCustomer().getValueCardAmountForSelectedLegalEntity() > 0 && !$scope.hasValueCardInBasket();
            } else {
                var valuecard = _.findWhere($rootScope.getActiveProducts(), {valuecard: true});
                return $scope.basket.find(item => item.product.id == valuecard.id) == null;
            }
        };

        var hasMoney = function() {
            var customer = $scope.getCustomer();
            if (customer) {
                return !$scope.purchase || customer.getValueCardAmountForSelectedLegalEntity() >= $scope.getTotalAmount();
            }
        };

        var hasSavedCard = function() {
            var customer = $scope.getCustomer();
            if (customer) {
                return customer.hasSavedCardForSelectedLegalEntity();
            }
        };

        var getNumberOfItemsOfTypeInBasket = function(card, variant) {
            var items = $scope.basket.filter(function(i) { return i.product == card && !i.payment && i.variant == variant; });
            var item = items.length && items[0];
            return item ? item.count : 0;
        };

        $scope.includedProductNeedsVariant = function(product) {
            return (product.included_products || []).some((productId) => {
                var p = _.findWhere($rootScope.trainingcardtypes, {id: productId});
                return p && p.needs_to_choose_variant && p.needs_to_choose_variant();
            });
        };

        $scope.stockEmpty = function(product) {
            if(product.stock == null) {return false;}

            if (product.variants) {
                return !product.variants.find(function(v) {
                    if (v.stock == null) {
                        return true;
                    }

                    var inBasket = getNumberOfItemsOfTypeInBasket(product, v.name);
                    if (v.stock - inBasket <= 0) {
                        return false;
                    }

                    return true;
                });
            }

            return product.stock - getNumberOfItemsOfTypeInBasket(product) <= 0;
        };

        $scope.getBuyableTrainingCards = function() {
            var cashier = $scope.getCashier();
            return $rootScope.getActiveTrainingCards().filter(function(card) {
                var rbonecard = card.resourcebookingservice_id && card.service_base_product;
                if (!$rootScope.productVisibleForCashier(card, cashier)) {
                    return false;
                }
                return !($scope.purchase && $scope.stockEmpty(card)) && !rbonecard && !card.workoutBooking && ((!card.priceType || card.priceType == 'OneTime') || ($scope.purchase && $scope.getCustomer()));
            });
        };

        $scope.getBuyableProducts = function() {
            var cashier = $scope.getCashier();
            return $rootScope.trainingcardtypes.filter(function(product) {
                if (!$scope.purchase && product.discount) {
                    return false;
                }
                if (!$rootScope.isProduct(product) || product.rounding || !product.active || product.misc || product.reminderFee || product.reminderRate || product.invoiceFee) {
                    return false;
                }
                if (product.valuecard && !$scope.getCustomer()) {
                    return false;
                }

                if (!$rootScope.productVisibleForSite(product)) {
                    return false;
                }

                if (!$rootScope.productVisibleForCashier(product, cashier)) {
                    return false;
                }

                return (!($scope.purchase && $scope.stockEmpty(product))) || product.valuecard;
            });
        };

        var isSwish = function() {
            var method = $scope.getMethod();
            return method && method.id == 'swish';
        };

        var getReceiptOptions = function() {
            return receiptoptions;
        };

        var customerItemFilter = function(item) {
            return !item.zoezi;
        };

        function showInvoiceFreeText() {
            var payMethod = _.findWhere($scope.fields, {name: 'method'}).value;
            return payMethod && payMethod.id === 'invoice';
        }

        $scope.openGetReceiptDialog = function() {
            $modal.open({
                templateUrl: 'views/addmodal.html',
                resolve: {
                    payments: $scope.payments,
                },
                controller: ['$scope', '$controller', 'server', 'alertProvider', function($scope, $controller, server, alertProvider) {
                    $controller('AddCtrl', { $scope: $scope });

                    $scope.title = 'Search via PSP-Reference';
                    $scope.getButtonText = function() {
                        return 'Add payment from receipt';
                    };

                    $scope.submit = function() {
                        $scope.loadingStatus.loading = true;

                        var item = $scope.getSubmitItem();
                        addPaymentsFromReceipt(item.externalReference).then(function() {
                            $scope.$close();
                            $scope.loadingStatus.loading = false;
                        });
                    };

                    $scope.fields = [
                        {name: 'externalReference', title: 'Get payment from receipt', focus: true, placeholder: 'PSP-Reference', type: 'text'},
                    ];
                }]
            });
        };

        $scope.fields = [
            {name: 'externalReference', title: 'Add payment', type: 'text', visible: $scope.paymentsAddedfromExternalPayment },
            {type: 'button', buttonTitle: 'Search via PSP-Reference', title: 'Add payment', click: $scope.openGetReceiptDialog, buttonClass: 'btn-success', visible: function() { return !$scope.purchase  && $scope.getCashier()?.terminal_handler == 'adyen'; } },
            {name: 'cashier', title: 'Cashier', type: 'cashier', required: true, open: true, visible: function() { return $rootScope.cashregisters.length != 1; } },
            {name: 'customer', title: 'Customer', type: 'customer', itemFilter: customerItemFilter, visible: function() { return $rootScope.hasPermission('Show customers'); }, change: customerChange },
            {name: 'seller', title: 'Seller', type: 'customer', itemTypes: ['staff'], required: true, visible: function() { return $rootScope.hasPermission('Show customers'); } },
            {name: 'method', title: 'Payment method', type: 'paymentmethod', hasMoney: hasMoney, required: true, options: paymentMethodOptions, hasSavedCard: hasSavedCard },
            {name: 'invoiceExtraInfo', title: 'Invoice comment (max 150 characters)', required: false, visible: showInvoiceFreeText, type: 'textarea', maxlength: 150 },
            {name: 'phone', title: 'Phone', type: 'phone', visible: isSwish, required: true },
            {name: 'receipt', title: 'Receipt', type: 'select', options: getReceiptOptions, required: true }
        ];
        $scope.hideSubmitButton = true;

        var showSwishDialog = function(transaction_id, onSuccess, onFailure, onFailureNoToast) {
            $modal.open({
                templateUrl: 'views/swish.html',
                controller: 'SwishCtrl',
                backdrop: 'static',
                resolve: {
                    options: function() {
                        return {
                            selfCheckout: $scope.selfCheckout,
                            transaction_id: transaction_id,
                            autoclose: 30000
                        };
                    }
                }
            }).result.then(function(notoast) {
                onSuccess(notoast);
            }, function(data) {
                if (data && data.notoast){
                    onFailureNoToast();
                } else if (data && data.type == 'ccu') {
                    onFailure(data);
                } else {
                    onFailure();
                }
            });
        };

        var showExternalPaymentDialog = function(transaction_id, amount, method, purchase, onSuccess, onFailure) {
            $modal.open({
                templateUrl: 'views/checkoutexternal.html',
                controller: 'CheckoutExternalCtrl',
                resolve: {
                    options: function() {
                        return {
                            transaction_id: transaction_id,
                            amount: amount,
                            method: method,
                            purchase: purchase
                        };
                    }
                }
            }).result.then(function() {
                onSuccess();
            }, function(data) {
                if (data && data.type == 'ccu') {
                    onFailure(data);
                } else {
                    onFailure();
                }
            });
        };

        $scope.pay = function() {
            $scope.loadingStatus.paying = true;

            var method;
            var amount = $scope.getTotalAmount();
            if (amount == 0 || !$scope.getMethod()) {
                method = 'cash';
            } else {
                method = $scope.getMethod().id;
            }

            if ($scope.paymentsAddedfromExternalPayment()) {
                //filter out payments not selected for refund
                $scope.basket = $scope.basket.filter(function(item) {
                    return item.selectedForRefund && !item.discount;
                });
            }

            var items = [];
            var priceRuleDiscounts = [];
            angular.forEach($scope.basket, function(item) {
                var i = {};
                if (item.price_rule_discount) {
                    // Collect price-rule discounts to attach to checkout metadata
                    priceRuleDiscounts.push({
                        rule_id: item.product.id,
                        amount: Math.abs(item.price),
                        source: 'price_rule',
                        name: item.extratext
                    });
                    return;
                }
                if (item.payment) {
                    i.payment = item.payment;
                    if (item.discounts) {
                        i.discounts = item.discounts;
                    }
                } else if (item.invoice) {
                    i.invoice = item.invoice.id;
                    i.price = item.price;
                } else {
                    i.product = item.product.id;
                    i.count = item.count;
                    i.price = item.price;
                    if (item.variant) {
                        i.variant = item.variant;
                    }
                    if (item.variants_for_included_products) {
                        i.variants_for_included_products = item.variants_for_included_products;
                    }
                    if (item.giftcard) {
                        i.giftcard = item.giftcard.id;
                    }
                    if (item.valuecard) {
                        i.valuecard = true;
                    }
                    if (item.product.discount) {
                        // Discounts are not included here
                        return;
                    }
                    if (item.barcode) {
                        i.barcode = item.barcode;
                    }
                    if (item.feeFor) {
                        i.is_onetime_fee = true;
                    } else if (item.discounts) {
                        i.discounts = item.discounts;
                    }

                    // Split package products into individual items (backend requires count=1 for included product expansion)
                    if ($rootScope.isPackageProduct(item.product) && item.count > 1) {
                        var unitPrice = item.price / item.count;
                        var unitDiscounts = (i.discounts || []).map((d) => {
                            return {id: d.id, amount: d.amount / item.count};
                        });

                        for (var n = 0; n < item.count; n++) {
                            items.push(angular.extend({}, i, {count: 1, price: unitPrice, discounts: unitDiscounts}));
                        }
                        return;
                    }
                }
                items.push(i);
            });

            var onSuccess = function(noToast) {
                if (!noToast) {
                    alertProvider.show('success', $scope.purchase ? 'Purchase complete' : 'Refund complete');
                }
                $scope.reset();
                $scope.loadingStatus.paying = false;
            };

            var onFailure = function(data) {
                if (data && data.type == 'ccu') {
                    $rootScope.$broadcast('ccufail', data.bundle_id);
                    $scope.reset();
                } else if (data && (data.type == 'pricerule_no_longer_available' || data.type == 'pricerule_limit_exceeded')) {
                    // Someone took the last discount while this basket was open.
                    // Nothing was charged — re-price so the cashier sees the
                    // real total before trying again. 
                    $scope.evaluatePriceRules();
                    alertProvider.show('error', $filter('translate')('The discount is no longer available. The price has been updated.'));
                } else if (data && data.type == 'pricerule_price_changed') {
                    // The opposite: a discount came back after this basket was
                    // priced, so the backend charges less than the cashier was
                    // shown. Re-price rather than charge an unagreed total.
                    $scope.evaluatePriceRules();
                    alertProvider.show('error', $filter('translate')('The pricing has changed. The price has been updated.'));
                } else {
                    var errorMsg = $scope.purchase ? 'Failed to perform purchase' : 'Failed to perform refund';
                    if (data && data.args && data.args.reason) {
                        errorMsg = data.args.reason;
                    } else if (data?.message) {
                        errorMsg = data.message;
                    }
                    alertProvider.show('error',  errorMsg);
                }
                $scope.loadingStatus.paying = false;
            };

            var onFailureNoToast = function() {
                $scope.loadingStatus.paying = false;
            };

            var confirmMethod = function(content, cashHelpAmount) {
                var deferred = $q.defer();
                var title = 'Confirm';

                var modalInstance = $modal.open({
                    templateUrl: '/views/checkoutconfirm.html',
                    controller: 'CheckoutConfirmModalCtrl',
                    resolve: {
                        options: function() {
                            return {title: title, content: content, cashHelpAmount: cashHelpAmount};
                        }
                    }
                });

                modalInstance.result.then(function () {
                    deferred.resolve();
                }, function() {
                    deferred.reject();
                });

                return deferred.promise;
            };

            var possiblyConfirmAmount = function() {
                if (method != 'izettle' && method != 'xcard' && method != 'swish' && method != 'adyen-terminal') {
                    var type = $scope.purchase ? 'Purchase' : 'Repurchase';
                    type = $filter('translate')(type).toLowerCase();
                    var amount = $scope.getTotalAmount();
                    var amountFormatted = formatter.format('price', amount);
                    var methodString = $filter('translate')($scope.getMethod() ? $scope.getMethod().name : 'cash');
                    var msg = $filter('translate')("Confirm {0} of {1}. Payment method: {2}").format(type, amountFormatted, methodString);
                    var cashHelpAmount = $scope.getMethod() ? ($scope.getMethod().id == 'cash' && $scope.purchase) ? amount : null : amount;
                    return confirmMethod(msg, cashHelpAmount);
                } else {
                    var deferred = $q.defer();
                    deferred.resolve();
                    return deferred.promise;
                }
            };

            var amount = $scope.getTotalAmount();

            var createStripeToken = function() {
                return $q.promise( function(resolve, reject) {
                    stripe.load().then(function() {
                        Stripe.source.create({
                            type: 'card',
                                card: {
                                number: $scope.stripeData.cardnumber,
                                cvc: $scope.stripeData.cvc,
                                exp_month: $scope.stripeData.exp_month,
                                exp_year: $scope.stripeData.exp_year
                            },
                        }, function(code, response) {
                            if(response.error) { reject(response.error.message); }
                            else if(code === 200) {
                                if(response.card.three_d_secure === 'required') {
                                    resolve({
                                        type: '3ds',
                                        source: response.id
                                    });
                                    $scope.$apply();
                                } else {
                                    resolve(response.id);
                                }
                            }
                        });
                    }, reject);
                });
            };

            var customer = $scope.getCustomer();
            // Include price rule discount code if used
            if ($scope._priceRuleCode) {
                items.push({type: 'price_rule_code', value: $scope._priceRuleCode});
            }
            var args = {
                method: method,
                cashregister: $scope.getCashier().id,
                receiptmethods: $scope.getReceiptMethods(),
                phone: $scope.getPhone(),
                seller_id: $scope.getSeller().id
            };
            // The rules this basket was priced with. The backend refuses the
            // sale if the set no longer matches, rather than silently charging
            // a total nobody agreed on. Always sent, 'none' included — silence
            // means "does not report", which skips the check entirely.
            var pricedWithRuleIds = _.uniq(_.pluck(priceRuleDiscounts, 'rule_id'));
            args.expected_pricerule_ids = pricedWithRuleIds.length ? pricedWithRuleIds.join(',') : 'none';
            if (customer) {
                args.payer = customer.id;
            }
            if (method == 'stripe') {
                if (!customer) {
                    createStripeToken().then(function(token) {
                        args.token = token;
                    }, function() { onFailure(); });
                } else if (!customer.hasSavedCardForSelectedLegalEntity()) {
                    createStripeToken().then(function(token) {
                        args.token = token;
                    }, function() { onFailure(); });
                }
            } else if (method == 'invoice') {
                args.invoiceExtraInfo = _.findWhere($scope.fields, {name: 'invoiceExtraInfo'}).value;
            }

            var methodObject = $scope.getMethod();
            args.refund = !$scope.purchase;
            possiblyConfirmAmount().then(function() {
                server.post('/api/checkout/checkout', items, args).then(function(result) {
                    if (result.success) {
                        if (method == 'swish') {
                            showSwishDialog(result.data.transaction_id, onSuccess, onFailure, onFailureNoToast);
                        } else if (result.data.type == 'adyen-terminal') {
                            const options = {
                                purchase: $scope.purchase,
                                ...result.data
                            };
                            $payment.adyenTerminal(options).then(onSuccess, onFailure).catch(() => onFailure());
                        } else if (method == 'xcard' && result.data.bambora) {
                            $payment.bamboraDialog({
                                controlKey: result.data.control_key,
                                pendingId: result.data.pending_id,
                                cashRegister: $scope.getCashier(),
                                autoclose: 30000
                            }).then(function(bamboraResponse) {
                                if(bamboraResponse.ccu_bandle_id) {
                                    onFailure({
                                        type: 'ccu',
                                        bundle_id: bamboraResponse.ccu_bandle_id
                                    });
                                } else {
                                    onSuccess(true);
                                }
                            }, function() {
                                onFailureNoToast();
                            });
                        } else if (result.data.transaction_id) {
                            showExternalPaymentDialog(result.data.transaction_id, amount, methodObject, $scope.purchase, onSuccess, onFailure);
                        } else {
                            onSuccess();
                        }
                    } else {
                        onFailure(result.data);
                    }
                });
            },
            function() {
                $scope.loadingStatus.paying = false;
            });
        };

        // FIXME: Possibly do this in a backend function only
        $scope.discountConditionsMet = function(product, discount) {
            if (product.type === undefined) {
                product = _.findWhere($rootScope.trainingcardtypes, {id: product.id});
            }

            if (product.discount || product.giftcard || product.valuecard) {
                return false;
            }

            if (discount.discount_condition) {
                var c = discount.discount_condition;

                // First check user related conditions
                if (c.user_status && c.user_status.length) {
                    let user = $scope.getCustomer();
                    let user_status_ids = user ? user.status.map(x => x.id) : [];
                    if (_.intersection(user_status_ids, c.user_status).length == 0) {
                        return false;
                    }
                }

                // Training cards
                if (product.type == 'trainingcard' && !product.trainingsessions) {
                    if (!c.trainingcards) {
                        return false;
                    }

                    if (!c.trainingcard_list || c.trainingcard_list.length == 0) {
                        return true;
                    }

                    return c.trainingcard_list.includes(product.id);
                }

                // Memberships
                if (product.type == 'membership') {
                    if (!c.memberships) {
                        return false;
                    }

                    if (!c.membership_list || c.membership_list.length == 0) {
                        return true;
                    }

                    return c.membership_list.includes(product.id);
                }

                 // Punch cards
                 if ((product.type == 'trainingcard' && product.trainingsessions) || (product.type == 'resourcebooking' && product.trainingsessions > 1)) {
                    if (!c.punchcards) {
                        return false;
                    }

                    if (!c.punchcard_list || c.punchcard_list.length == 0) {
                        return true;
                    }

                    return c.punchcard_list.includes(product.id);
                 }

                 // Products
                 if (!product.type) {
                    if (!c.products) {
                        return false;
                    }

                    let category_condition = (!c.product_categories || c.product_categories.length == 0) || c.product_categories.includes(product.product_category_id) || c.product_categories.includes(product.product_webshop_category_id);
                    let product_condition = (!c.product_list || c.product_list.length == 0) || c.product_list.includes(product.id);
                    return category_condition && product_condition;
                 }

                 // Courses
                 if (product.type == 'course') {
                    if (!c.courses) {
                        return false;
                    }
                    // FIXME: Category condition is not checked
                    return true;
                 }

                 // Services
                 if (product.type == 'resourcebooking') {
                    if (!c.services) {
                        return false;
                    }

                    if (!c.service_list || c.service_list.length == 0) {
                        return true;
                    }

                    // FIXME: Category

                    return c.service_list.includes(product.resourcebookingservice_id);
                 }

            } else {
                return true;
            }
        };

        function getItemDiscountsSum(item) {
            let total = 0;
            (item.discounts || []).forEach(i => total += i.amount);
            return total;
        }

        $scope.applyDiscount = function(discount, amount, discount_for_payment_id) {
            if (discount_for_payment_id){
                let item = $scope.basket.find(i => i.payment == discount_for_payment_id);
                if (item) {
                    // Remove the discount
                    item.discounts = (item.discounts || []).filter(function(d) { return d.id != discount.id; });
                    // Add it
                    item.discounts.push({id: discount.id, amount});
                    return amount;
                }
                return 0;
            }

            var total = 0;

            var totalForThisDiscount = 0;
            $scope.basket.forEach(function(item) {
                if (!item.feeFor && $scope.discountConditionsMet(item.product, discount)) {
                    totalForThisDiscount += Number(item.price);
                }
            });

            $scope.basket.forEach(function(item) {
                if (!item.feeFor && $scope.discountConditionsMet(item.product, discount)) {
                    // item: {product, price, discount, discounts}
                    var item_amount = Number(item.price);
                    var discount_amount = item_amount * (discount.discount_percent / 100);

                    if (amount || discount.discount_fixed) {
                        var fixed = Number(amount || discount.discount_fixed);
                        var thisPart = item_amount / totalForThisDiscount;
                        discount_amount += thisPart * fixed;
                    }
                    discount_amount = Math.min(item_amount, discount_amount);

                    // Remove the discount
                    item.discounts = (item.discounts || []).filter(function(d) { return d.id != discount.id; });

                    let other_discounts = getItemDiscountsSum(item);
                    discount_amount = Math.min( item_amount - other_discounts, discount_amount );

                    // Add it
                    item.discounts.push({id: discount.id, amount: discount_amount});

                    total += discount_amount;
                }
            });
            return total;
        };

        $scope.getTotalAmountBeforeDiscountAndGiftcards = function() {
            var total = 0;
            angular.forEach($scope.basket, function(item) {
                if (!item.product.discount && !item.product.valuecard && !item.product.giftcard) {
                    total += Number(item.price);
                }
            });
            return total;
        };

        $scope.getTotalAmountAdyenRefund = function() {
            var total = 0;
            angular.forEach($scope.basket, function(item) {
                if (item.selectedForRefund) {
                    total += Number(item.price);
                }
            });
            return Math.round(total);
        };

        $scope.getTotalAmount = function() {
            if ($scope.paymentsAddedfromExternalPayment()) {
                return $scope.getTotalAmountAdyenRefund();
            }
            var total = 0;
            angular.forEach($scope.basket, function(item) {
                total += Number(item.price);
            });
            return Math.round(total);
        };

        $scope.hasPendingOrUnpaidOrSent = function() {
            var pendingConfig = util.findScope($scope, 'pendingConfig');
            var unpaidConfig = util.findScope($scope, 'unpaidConfig');
            var sentConfig = util.findScope($scope, 'sentConfig');
            var pending = pendingConfig && pendingConfig.control && pendingConfig.control.getNumberOfItems();
            var unpaid = unpaidConfig && unpaidConfig.control && unpaidConfig.control.getNumberOfItems();
            var sent = sentConfig && sentConfig.control && sentConfig.control.getNumberOfItems();
            return pending || unpaid || sent;
        };

        $scope.invoiceInBasket = function() {
            return $scope.basket.filter(function(i) { return i.invoice; } ).length > 0;
        };

        $scope.canAddDiscount = function() {
            return $scope.purchase && !$scope.invoiceInBasket();
        };

        var basketContainsPayments = function() {
            return _.find($scope.basket, function(i) { return i.payment;});
        };

        $scope.basketContainsGiftCardWithDiscount = function() {
            var giftcards = $scope.basket.filter(function(item) {
                return item.product && item.product.giftcard;
            });
            var valuecard = $scope.basket.filter(function(item) {
                return item.product && item.product.valuecard;
            });

            var discounts = $scope.basket.filter(function(item) {
                return item.product && item.product.discount;
            });

            return (giftcards.length + valuecard.length) > 0 && discounts.length > 0;
        };

        $scope.basketContainsSomethingToPay = function() {
            var tobuy = $scope.basket.filter(function(item) {
                return (item.product && !item.product.discount && !item.giftcard && !item.valuecard) || item.invoice;
            });
            return tobuy.length > 0;
        };

        $scope.basketContainsTrainingCards = function() {
            return _.find($scope.basket, function(i) { return i.product && (i.product.type == 'resourcebooking' || i.product.type == 'trainingcard' || i.product.membership); });
        };

        var canAddTrainingCard = function(product) {
            const discountsInBasket = $scope.basket.filter(i => i.product && i.product.discount);
            const trainingcardOrMembershipInBasket = $scope.basket.some(i => i.product && (i.product.type == 'trainingcard' || i.product.membership));

            // Only allow one discount if there is a training card or membership in the basket
            if (product.discount && trainingcardOrMembershipInBasket && discountsInBasket.length > 0) {
                alertProvider.modal('Failed', 'You cannot purchase a training card or membership with multiple discounts applied');
                return false;
            }

            // Dont allow adding trainingcard/memberhsip if there is more than one discount in the basket
            if ((product.type == 'trainingcard' || product.membership) && discountsInBasket.length > 1) {
                alertProvider.modal('Failed', 'You cannot purchase a training card or membership with multiple discounts applied');
                return false;
            }

            return true;
        };

        $scope.addProduct = function(product, variant) {
            if (!canAddTrainingCard(product)) {
                return;
            }

            if(product.priceType && product.priceType !== 'OneTime') {
                $rootScope.showCombo({customer: $scope.getCustomer(), trainingcard: product});
            } else if (product.discount) {
                var items = $scope.basket.filter(function(i) { return i.product == product && !i.payment; });
                var item = items.length && items[0];
                if (item) {
                    return;
                }
                if (product.payWhatYouWant) {
                    var modalInstance = $modal.open({
                        templateUrl: 'views/getamountmodal.html',
                        controller: 'AmountCtrl',
                        resolve: {
                            amount: function() { return  product.price; },
                            option: function() { return {};}
                        }
                    });
                    modalInstance.result.then(function (amount) {
                        $scope.addDiscount(product, amount);
                        $scope.recalculateBasket();
                    });
                } else {
                    $scope.addDiscount(product);
                    $scope.recalculateBasket();
                }
            } else if (product.payWhatYouWant && $scope.selfCheckout) {
                var addProduct = function(amount) {
                    var items = $scope.basket.filter(function(i) { return i.product == product && !i.payment; });
                    var item = items.length && items[0];
                    if (!item) {
                        item = {product: product, count: 1, payWhatYouWant: true, price: amount};
                        $scope.basket.push(item);
                        $scope.recalculateBasket();
                    } else {
                        item.price = amount;
                    }
                    $scope.$apply();
                };

                if ($scope.selfCheckout) {
                    $('#selfcheckout').numpad({
                        type: 'numerical',
                        target: addProduct,
                        placeholder: $filter('translate')('Enter amount'),
                        textClear: $filter('translate')('Clear'),
                        textCancel: $filter('translate')('Cancel')
                    });
                } else {
                    var modalInstance = $modal.open({
                        templateUrl: 'views/getamountmodal.html',
                        controller: 'AmountCtrl',
                        resolve: {
                            amount: function() { return  product.price; },
                            option: function() { return {};}
                        }
                    });

                    modalInstance.result.then(addProduct);
                }
            } else if (!$scope.purchase || (variant || product.needs_to_choose_variant()) || product.payWhatYouWant || $scope.includedProductNeedsVariant(product)) {
                var products_in_basket = $scope.basket.filter(function(i) { return i.product == product && !i.payment; });

                var done = function(result) {
                    var items = $scope.basket.filter(function(i) { return i.product == product && !i.payment && i.variant == result.variant; });
                    var item  = items.length && items[0];
                    if (item && item.product && item.product.type == 'giftcard') {
                        item = null;
                    }
                    // Package products with included product variants must be separate basket items
                    // so each instance can have its own variant selections
                    if (item && result.variants_for_included_products) {
                        item = null;
                    }
                    var price = Number((product.payWhatYouWant || $scope.getCashier().can_change_price || !$scope.purchase) && result.price ? result.price : (product.price * result.count));
                    if (!item) {
                        item = {product: product, count: result.count || 1, price: price, variant: result.variant};
                        $scope.basket.push(item);
                    } else {
                        if (product.payWhatYouWant) {
                            item.price = price;
                        } else {
                            item.price += price;
                            item.count += result.count;
                        }
                    }
                    item.barcode = result.barcode;
                    if (result.variants_for_included_products) {
                        item.variants_for_included_products = result.variants_for_included_products;
                    }

                    if ($scope.purchase && $rootScope.hasFlag('flag-one-time-fee') && product.onetime_fee_product && product.onetime_fee_product.price > 0 && (!product.onetime_fee_product.priceType || product.onetime_fee_product.priceType === 'OneTime')) {
                        var feeProduct = product.onetime_fee_product;
                        var addedCount = result.count || 1;
                        if (!item.feeItem) {
                            var feeItem = {product: feeProduct, count: addedCount, price: Number(feeProduct.price) * addedCount, feeFor: item};
                            item.feeItem = feeItem;
                            $scope.basket.push(feeItem);
                        } else {
                            item.feeItem.count += addedCount;
                            item.feeItem.price += Number(feeProduct.price) * addedCount;
                        }
                    }

                    $scope.recalculateBasket();
                };
                if (variant) {
                    done({variant: variant, count: 1});
                } else {
                    $modal.open({
                        templateUrl: 'views/getvariant.html',
                        controller: 'GetVariantCtrl',
                        resolve: {
                            options: function() { return {
                                product: product,
                                variant: variant,
                                basket: products_in_basket,
                                showDescription: false,
                                showCount: !product.payWhatYouWant,
                                showPrice: product.payWhatYouWant || !$scope.purchase || $scope.getCashier().can_change_price,
                                checkStock: $scope.purchase,
                                require_barcode: $scope.getCashier().require_barcode,
                                showBarcode: product.type == 'giftcard'
                            };}
                        }
                    }).result.then(done);
                }
            } else {
                var multipleTrials = $scope.basket.filter(function(i) { return i.count == 1 && i.product.trial;}).length == 1;
                var items = $scope.basket.filter(function(i) { return i.product == product && !i.payment; });
                var item = items.length && items[0];

                if (item && multipleTrials) {
                    alertProvider.modal('Failed', 'CAN_ONLY_BUY_ONE_WEBSHOP');
                } else if (!item || product.giftcard || product.type == 'trainingcard' || product.type == 'resourcebooking') {
                    item = {product: product, count: 1, price: Number(product.price) };
                    $scope.basket.push(item);
                    if ($scope.purchase && $rootScope.hasFlag('flag-one-time-fee') && product.onetime_fee_product && product.onetime_fee_product.price > 0 && (!product.onetime_fee_product.priceType || product.onetime_fee_product.priceType === 'OneTime')) {
                        var feeProduct = product.onetime_fee_product;
                        var feeItem = {product: feeProduct, count: 1, price: Number(feeProduct.price), feeFor: item};
                        item.feeItem = feeItem;
                        $scope.basket.push(feeItem);
                    }
                } else {
                    item.price += Number(product.price);
                    ++item.count;
                    if ($scope.purchase && $rootScope.hasFlag('flag-one-time-fee') && item.feeItem) {
                        item.feeItem.price += Number(item.feeItem.product.price);
                        ++item.feeItem.count;
                    }
                }

                $scope.recalculateBasket();
            }
        };

        $scope.removeItem = function(item) {
            if (item.payWhatYouWant) {
                $scope.basket.splice($scope.basket.indexOf(item), 1);
                $scope.recalculateBasket();
                return;
            }

            --item.count;
            item.price -= Number(item.invoice ? item.price : item.product.price);
            if (item.count == 0) {
                $scope.basket.splice($scope.basket.indexOf(item), 1);

                if ($rootScope.hasFlag('flag-one-time-fee')) {
                    if (item.feeItem) {
                        var linkedIdx = $scope.basket.indexOf(item.feeItem);
                        if (linkedIdx !== -1) {
                            $scope.basket.splice(linkedIdx, 1);
                        }
                    } else if (item.feeFor) {
                        item.feeFor.feeItem = null;
                    }
                }

                if (item.product?.discount) {
                    $scope.basket.forEach(bi => {
                        if (bi.discounts) {
                            bi.discounts = bi.discounts.filter(function(d) { return d.id != item.product.id; });
                        }
                    });
                }
            } else if ($rootScope.hasFlag('flag-one-time-fee') && item.feeItem) {
                item.feeItem.price -= Number(item.feeItem.product.price);
                --item.feeItem.count;
            }

            if (item.payment || item.invoice) {
                $scope.updateEconomyTables();
            }

            $scope.recalculateBasket();
        };

        $scope.changePrice = function(item) {
            if (!$scope.getCashier().can_change_price || ($rootScope.hasFlag('flag-one-time-fee') && item.feeFor)) {
                return;
            }

            $modal.open({
                templateUrl: 'views/getamountmodal.html',
                controller: 'AmountCtrl',
                resolve: {
                    amount: function() { return item.price; },
                    option: function() { return {};}
                }
            }).result.then(function (amount) {
                item.price = amount;
                $scope.recalculateBasket();
            });
        };

        $scope.canPay = function() {
            var form = util.findScope($scope, 'form');
            if (!form || !form.$valid) {
                return false;
            }

            if ($scope.basket.length == 0) {
                return false;
            }
            var method, totalAmount = $scope.getTotalAmount();
            if(totalAmount == 0) {method = 'cash';}
            else {
                method = $scope.getMethod();
                if(!method) {return false;}
                method = method.id;
            }

            var cashier = $scope.getCashier();
            if (!cashier) {
                return false;
            }

            if (method == 'invoice' ||
                method == 'valuecard' ||
                method == 'einvoice' ||
                method == 'directdebit') {
                if (!$scope.getCustomer()) {
                    return false;
                }
            }

            if ($scope.getReceiptMethods().length == 0) {
                return false;
            }

            if ((basketContainsPayments() || $scope.invoiceInBasket()) && (method == 'invoice' || method == 'einvoice' || method == 'directdebit')) {
                return false;
            }

            if ($scope.basketContainsTrainingCards() && !$scope.getCustomer()) {
                return false;
            }

            if (!$scope.purchase && method == 'cash' && cashier.cash < totalAmount) {
                return false;
            }

            if (method == 'swish' && !$scope.getPhone()) {
                return false;
            }

            if ($scope.purchase && method == 'valuecard' && (!$scope.getCustomer() || $scope.getCustomer().getValueCardAmountForSelectedLegalEntity() < $scope.getTotalAmount())) {
                return false;
            }

            if ($scope.basketContainsGiftCardWithDiscount()) {
                return false;
            }

            if ($scope.purchase && !$scope.basketContainsSomethingToPay()) {
                return false;
            }

            if (!$scope.purchase) {
                var customer = $scope.getCustomer();
                var valuecard = 0;
                $scope.basket.forEach(function(i) {
                    if(i.product && i.product.valuecard) {
                        valuecard += Number(i.price);
                    }
                });
                if (valuecard) {
                    if (!customer) {return false;}
                    if (Number(customer.getValueCardAmountForSelectedLegalEntity()) < valuecard) {return false;}
                }

                if ($scope.getTotalAmount() == 0) {
                    return false;
                }
            }

            return true;
         };

        var doesNotHavePayment = function(payment) {
            return !_.findWhere($scope.basket, {payment: payment.id});
        };

        var getPaymentLegalEntityId = function(payment) {
            var siteId = payment.site_id || (payment.parts && payment.parts[0] && payment.parts[0].site_id);
            if (!siteId) return null;
            var site = _.findWhere($rootScope.sites, {id: siteId});
            return site ? site.legal_entity_id : null;
        };

        var isPaymentForCurrentEntity = function(payment) {
            if (!$rootScope.hasModule('MultipleLegalEntities')) return true;
            var entityId = getPaymentLegalEntityId(payment);
            return !entityId || entityId === $rootScope.selectedSite.legal_entity_id;
        };

        var getPaymentLegalEntityName = function(payment) {
            var entityId = getPaymentLegalEntityId(payment);
            if (!entityId) return '';
            var site = _.find($rootScope.sites, function(s) { return s.legal_entity_id === entityId; });
            return site && site.legal_entity ? site.legal_entity.name : '';
        };

        var handleWrongEntityPayment = function(payment) {
            var entityName = getPaymentLegalEntityName(payment);
            var siteId = payment.site_id || (payment.parts && payment.parts[0] && payment.parts[0].site_id);
            var targetSite = _.findWhere($rootScope.sites, {id: siteId});
            if (!targetSite) return;

            confirm.show(
                $filter('translate')('PAYMENT_WRONG_ENTITY').format(entityName),
                {yesButtonText: $filter('translate')('Yes, switch'), noButtonText: $filter('translate')('Stay')}
            ).then(function() {
                var customer = $scope.getCustomer ? $scope.getCustomer() : null;
                var transferData = {};
                if (payment.referenceNumber || payment.invoice_id) {
                    transferData.invoice = payment;
                } else {
                    transferData.payments = payment.parts;
                }
                if (customer) {
                    transferData.customer = customer;
                }
                cashiers.transfer(transferData);
                $rootScope.setSiteOnServer(targetSite);
                $rootScope.setSite(targetSite.id);
            });
        };

        // function(p) { return p.method == 'invoice' && $scope.basket.length == 0; }
        var canAddPayment = function(payment) {
            if (!$scope.purchase) {return false;}
            if (!isPaymentForCurrentEntity(payment)) {return false;}
            if (payment.invoiceNumber) {
                if ($scope.basket.length != 0) {
                    return false;
                }
                if (payment.method == 'directdebit' && payment.status == 'sent') {
                    return false;
                }
                return true;
            } else if(payment.status != 'sent') {
                return doesNotHavePayment(payment);
            }
        };

        var addInvoice = function(payment) {
            if (!canAddPayment(payment)) {
                return;
            }

            var left = payment.remainingAmountToPay;

            $scope.basket.push( { invoice: { invoiceNumber: payment.invoiceNumber, amount: left, id: payment.invoice_id }, count: 1, price: left });
            payment.reminders.forEach(function(r) {
                if (r.fee_payment && r.fee_payment.status != 'paid') {
                    addPayment(r.fee_payment);
                }
                if (r.rate_payment  && r.rate_payment.status != 'paid') {
                    addPayment(r.rate_payment);
                }
            });

            $scope.updateEconomyTables();
            $scope.recalculateBasket();
        };

        var addPaymentsFromPayment = function(payment) {
            if (!isPaymentForCurrentEntity(payment)) {
                handleWrongEntityPayment(payment);
                return;
            }
            if (!canAddPayment(payment)) {
                return;
            }
            if (payment.status == 'sent' || payment.invoice_id) {
                addInvoice(payment);
            } else {
                angular.forEach(payment.parts, function(payment) {
                    addPayment(payment);
                });
            }
        };

        var isWrongEntityPayment = function(payment) {
            return $rootScope.hasModule('MultipleLegalEntities') && !isPaymentForCurrentEntity(payment);
        };

        economyConfig = {
            unpaid: {
                buttons: [
                    {title: 'Pay at checkout', onClick: addPaymentsFromPayment, visible: canAddPayment },
                    {title: 'Switch entity', onClick: handleWrongEntityPayment, visible: isWrongEntityPayment, buttonClass: 'btn-warning' }
                ],
                searchButtons: [],
                hidePaymentSearch: true,
                rowClick: addPaymentsFromPayment
            },
            pending: {
                buttons: [
                    {title: 'Pay at checkout', onClick: addPaymentsFromPayment, visible: canAddPayment },
                    {title: 'Switch entity', onClick: handleWrongEntityPayment, visible: isWrongEntityPayment, buttonClass: 'btn-warning' }
                ],
                searchButtons: [],
                hidePaymentSearch: true,
                hideFromDate: true,
                rowClick: addPaymentsFromPayment
            },
            sent: {
                buttons: [
                    {title: 'Pay at checkout', onClick: addPaymentsFromPayment, visible: canAddPayment },
                    {title: 'Switch entity', onClick: handleWrongEntityPayment, visible: isWrongEntityPayment, buttonClass: 'btn-warning' }
                ],
                searchButtons: [],
                hidePaymentSearch: true,
                hideFromDate: true,
                rowClick: addPaymentsFromPayment
            },
            debtcollection:null,
            history: null
        };

        $scope.updateEconomyTables = function() {
            if (economyConfig.unpaid.update) {
                economyConfig.unpaid.update();
            }
            if (economyConfig.pending.update) {
                economyConfig.pending.update();
            }
            if (economyConfig.sent.update) {
                economyConfig.sent.update();
            }
        };

        $scope.getEconomyConfig = function() {
            return economyConfig;
        };

        $scope.updateReceiptOptions = function() {
            var printer = $scope.getCashier() && $scope.getCashier().printer_id;
            var sms = $rootScope.hasModule('SMS') && (($scope.getCustomer() && $scope.getCustomer().phone) || $scope.getPhone());
            var mail = $scope.getCustomer() && $scope.getCustomer().mail;
            receiptoptions = [];
            if (printer) {
                receiptoptions.push(receipttypes.printer);
            }
            if (sms) {
                receiptoptions.push(receipttypes.sms);
            }
            if (mail) {
                receiptoptions.push(receipttypes.mail);
            }
            receiptoptions.push(receipttypes.trash);

            _.findWhere($scope.fields, {name: 'receipt'}).value = null;
            if (mail) {
                _.findWhere($scope.fields, {name: 'receipt'}).value = receipttypes.mail;
            } else if (sms) {
                _.findWhere($scope.fields, {name: 'receipt'}).value = receipttypes.sms;
            } else if (printer) {
                _.findWhere($scope.fields, {name: 'receipt'}).value = receipttypes.printer;
            } else {
                _.findWhere($scope.fields, {name: 'receipt'}).value = receipttypes.trash;
            }
        };

        $scope.$watch($scope.getCustomer, function(customer) {
            _.findWhere($scope.fields, {name: 'phone'}).value = customer && customer.phone;
            $scope.updateReceiptOptions();
        }, true);

        var transferedMethod;

        $scope.$watch($scope.getCashier, function(cashier) {
            if ($scope.selfCheckout) { return; }
            $scope.updateReceiptOptions();

            if (cashier && cashier.selfcheckout) {
                $location.path('/pages/selfcheckout/' + cashier.id);
            } else if(!transferedMethod) {
                _.findWhere($scope.fields, {name: 'method'}).value = getDefaultMethod(!$scope.purchase);
            }
        });

        $scope.$watch($scope.getPhone, function() {
            $scope.updateReceiptOptions();
        });

        function applyTransfer() {
            if (!cashiers.getTransfer()) return;
            var transfer = cashiers.getTransfer();
            if (transfer.payments) {
                var payer = transfer.payments[0].payer;
                _.findWhere($scope.fields, {name: 'customer'}).value = payer ? $rootScope.transformMember(payer) : payer;
                angular.forEach(transfer.payments, function(payment) {
                    addPayment(payment);
                });
            }
            if (transfer.invoice) {
                var payer = transfer.invoice.payer;
                _.findWhere($scope.fields, {name: 'customer'}).value = payer ? $rootScope.transformMember(payer) : payer;
                addInvoice(transfer.invoice);
            }
            if (transfer.customer) {
                _.findWhere($scope.fields, {name: 'customer'}).value = $rootScope.transformMember(transfer.customer);
            }
            if (transfer.basket) {
                $scope.basket = transfer.basket.map(function(item) {
                    if (item.product_id) {
                        item.product = _.findWhere($rootScope.trainingcardtypes, {id: item.product_id});
                    }
                    return item;
                });
            }
            if (transfer.purchase !== undefined) {
                $scope.purchase = transfer.purchase;
            }
            if (transfer.method && paymentMethods.getFilter('checkout')(transfer.method)) {
                _.findWhere($scope.fields, {name: 'method'}).value = transfer.method;
                transferedMethod = true;
            }
            cashiers.transfer(null);
            $scope.recalculateBasket();
        }

        $scope.pubsub('selectedSite', () => {
            let openedCashier = $scope.getCashier();
            if (openedCashier && openedCashier.site_id != $rootScope.selectedSite.id) {
                _.findWhere($scope.fields, {name: 'cashier'}).value = null;
            }
            $scope.reset();
            $scope.openCashier();
            applyTransfer();
        });

        $scope.openCashier = function() {
            if ($scope.selfCheckout) { return; }

            // Don't force close modals if we're running inside the top modal ourselves
            var topModal = modalUtils.getTop();
            var isInsideModal = topModal?.value?.modalScope === $scope;

            if (!isInsideModal) {
                modalUtils.forceCloseAllModals();
            }

            $rootScope.getCashierForField(_.findWhere($scope.fields, {name: 'cashier'}), true);
        };

        $scope.changeAmount = function() {
            var cashier = $scope.getCashier();
            cashiers.getChangeAmount(cashier.cash, {
                disabled: function(amount) {return amount == cashier.cash;},
                registerCoins: cashier.registercoins
            }).then(function(amount) {
                server.post('/api/checkout/cashier/cash/set', null, {id: cashier.id, cash: amount});
            });
        };

        $scope.reset();
        $scope.openCashier();
        applyTransfer();

        function isSmallScreen() {
            return window.innerWidth <= 768 || window.innerHeight < 300;
        }

        setTimeout(function() {
            if(isSmallScreen() || $scope.selfCheckout) {return;}

            //var $form = $($scope.elForm);
            var $list = $($scope.checkoutForm.elList);
            var $container = $('#content');
            var visible = false;
            var scrollTop = 0;

            function move() {
                if(isSmallScreen()) {
                    if ($scope.checkoutForm.elForm) {
                        $scope.checkoutForm.elForm.style.top = '0px';
                    }
                    if ($scope.checkoutForm.elList) {
                        $scope.checkoutForm.elList.style.top = '0px';
                    }
                    //$form.removeClass('co-form-base-transition');
                    return;
                }
                let form = $scope.checkoutForm.elForm;
                let header = $scope.checkoutForm.elHeader;
                let list = $scope.checkoutForm.elList;
                if (!form || !list || !header) {
                    return;
                }

                var top = scrollTop - 60;
                let elHtop = $(header).position().top;
                if(!visible) {top-=elHtop;}
                if(top < 0) {top = 0;}
                form.style.top = top + 'px';

                var originalTop = $list.position().top - parseFloat(list.style.top || 0);
                var topList = scrollTop - originalTop + 50;
                if($list.height() + 100 > $container.height()) {
                    topList -= $list.height() + 100 - $container.height();
                }
                if(topList < 0) {topList = 0;}
                list.style.top = topList + 'px';
            }

            $scope.$watch('basket.length', function() {
                setTimeout(move, 50);
            });

            /*
            // show whole form on hover
            var timeout = null;
            $form.on('mouseenter', function() {
                visible = true;
                $form.addClass('co-form-base-transition');
                setTimeout(move, 10);
                if(timeout) {
                    clearTimeout(timeout);
                    timeout = null;
                }
            });
            $form.on('mouseleave', function() {
                visible = false;
                move();
                if(timeout) {
                    clearTimeout(timeout);
                }
                timeout = setTimeout(function() {
                    timeout = null;
                    $form.removeClass('co-form-base-transition');
                }, 1000);
            });
            */

            function onScroll() {
                scrollTop = $('#content').scrollTop();
                move();
            }
            $(window).on('resize', onScroll);
            $container.on('scroll', onScroll);
            $scope.$on('$destroy', function() {
                $(window).off('resize', onScroll);
                $container.off('scroll', onScroll);
            });

            $scope.$watch(function() {
                var cashier = $scope.getCashier();
                if(!cashier) {return;}
                return cashier.id + '-' + cashier.opened;
            }, move);

        }, 100);
    });
}]);

checkout.controller('SelfCheckoutCtrl', ['$rootScope', '$scope', '$controller', '$filter', '$routeParams', '$location', '$timeout', 'server', 'live', 'paymentMethods', 'alertProvider', function($rootScope, $scope, $controller, $filter, $routeParams, $location, $timeout, server, live, paymentMethods, alertProvider) {
    $scope.selfCheckout = true;
    $controller('CheckoutCtrl', {$scope: $scope});
    $rootScope.waitFor(['paymentmethods', 'cashregisters']).then(function() {
        $scope.phone = _.findWhere($scope.fields, {name: 'phone'});
        $scope.stripeData = {};

        function setPaymentMethods() {

            function validAddress(customer) {
                if (!customer) { return; }
                return customer.address && customer.zipCode && customer.city;
            }

            function haveConsent(customer) {
                return customer?.consents?.[$rootScope.selectedSite?.legal_entity_id];
            }

            var customer = $scope.getCustomer();

            $scope.paymentMethods = paymentMethods.get().filter(function(m) {

                // Conditions for self-checkout payment methods
                const isSwish = m.id === 'swish';
                const isInvoiceWithValidAddress = m.id === 'invoice' && validAddress(customer);
                const isDirectDebitWithConsent = m.id === 'directdebit' && haveConsent(customer);
                const isSelfCheckout = m.selfCheckout && (isSwish || isInvoiceWithValidAddress || isDirectDebitWithConsent);

                // Get cashier details
                const cashier = $scope.getCashier();
                const isXCardAllowed = m.id === 'xcard' && cashier && cashier.terminal_handler === 'bambora';
                const isAdyenTerminalAllowed = m.id === 'adyen-terminal' && cashier && cashier.terminal_handler === 'adyen';

                return m.active && (isSelfCheckout || isXCardAllowed || isAdyenTerminalAllowed);
            });
            $scope.valuecard = paymentMethods.get().find(function(m) { return m.id == 'valuecard'; });
        }

        var resetTimer;
        function cancelTimer() {
            $timeout.cancel(resetTimer);
        }

        function startTimer() {
            cancelTimer();
            resetTimer = $timeout(function() {
                if ($scope.loadingStatus.paying) {
                    startTimer();
                } else {
                    $scope.reset();
                }
            }, 120000);
        }

        $scope.getStripeCard = function() {
            var customer = $scope.getCustomer();
            if (customer) { return customer.hasSavedCardForSelectedLegalEntity(); }
        };

        $scope.welcomeMessage = function() {
            if ($scope.getCustomer()) {
                setPaymentMethods();
                return $filter('translate')('CHECKOUT_WELCOME_CUSTOMER').format($scope.getCustomer().firstname);
            }
            return $filter('translate')('CHECKOUT_WELCOME_ANONYMOUS');
        };

        $scope.getBuyableTrainingCards = function() {
            if (!$scope.getCustomer()) { return []; }
            var cashier = $scope.getCashier();
            return $rootScope.getActiveTrainingCards().filter(function(card) {
                var rbonecard = card.resourcebookingservice_id && card.service_base_product;
                if (!$rootScope.productVisibleForCashier(card, cashier)) {
                    return false;
                }
                return card.showSelfCheckout && !($scope.purchase && $scope.stockEmpty(card)) && !rbonecard && !card.workoutBooking && (!card.priceType || card.priceType == 'OneTime');
            });
        };

        $scope.getBuyableProducts = function() {
            var cashier = $scope.getCashier();
            return $rootScope.trainingcardtypes.filter(function(product) {
                if (!$rootScope.isProduct(product) || !product.showSelfCheckout || product.rounding || !product.active || product.misc || product.reminderFee || product.reminderRate || product.invoiceFee || product.discount || product.blockFee) {
                    return false;
                }
                if (!$scope.getCustomer() && (product.membership || product.valuecard)) {
                    return false;
                }
                if (!$rootScope.productVisibleForCashier(product, cashier)) {
                    return false;
                }
                return (!($scope.purchase && $scope.stockEmpty(product))) || product.valuecard;
            });
        };

        $scope.selectMethod = function(method) {
            _.findWhere($scope.fields, {name: 'method'}).value = method;
        };

        $scope.isSelectedMethod = function(method) {
            return _.findWhere($scope.fields, {name: 'method'}).value == method;
        };

        $scope.getSelectedMethod = function() {
            var pm = _.findWhere($scope.fields, {name: 'method'}).value;
            if (pm) { return pm.id; }
            return pm;
        };

        $scope.canPay = function() {
            var method = $scope.getMethod();
            if ($scope.basket.length == 0) {
                return false;
            }

            var cashier = $scope.getCashier();
            if (!cashier) {
                return false;
            }

            if ($scope.getReceiptMethods().length == 0) {
                return false;
            }

            if ($scope.getTotalAmount() == 0) {
                return true;
            }

            if (!method) {
                return false;
            }

            if (method.id == 'swish' && !$scope.getPhone()) {
                return false;
            }

            if ($scope.basketContainsGiftCardWithDiscount()) {
                return false;
            }

            if ($scope.purchase && !$scope.basketContainsSomethingToPay()) {
                return false;
            }

            return true;
         };

        var pay = $scope.pay;
        $scope.pay = function() {
            if ($scope.hasValueCardInBasket() && $scope.getTotalAmount() == 0) {
                $scope.selectMethod($scope.valuecard);
            }
            pay();
        };

        $scope.cancelPurchase = function() {
            cancelTimer();
            $scope.reset();
        };

        $scope.checkGiftCard = function(code) {
            $scope.loadingStatus.loading = true;
            var legal_entity_id = $rootScope.selectedSite ? $rootScope.selectedSite.legal_entity_id : null;
            server.get('/api/public/giftcard/verify', {code: code, allow_barcode: false, legal_entity_id: legal_entity_id}).then(function(result) {
                if (result.found && result.card && Number(result.card.amount) > 0 && !result.expired && result.paid && !result.wrong_legal_entity) {
                    var giftcard = {id: result.card.id, product_id: result.card.cardtype_id, amount: result.card.amount, percentage: result.card.percentage, type: result.type, name: result.card.name, code: code };
                    $scope.addGiftCard(giftcard);
                } else if (result.found && result.card.amount == 0) {
                    alertProvider.show('error', 'There is no money left on the gift card');
                } else if (result.wrong_legal_entity) {
                    alertProvider.show('error', 'Gift card belongs to a different legal entity');
                } else if (!result.found) {
                    alertProvider.show('error', 'Gift card could not be found');
                } else if (!result.paid) {
                    alertProvider.show('error', 'Gift card is not paid');
                }

                $scope.loadingStatus.loading = false;
            });
        };

        $scope.enterGiftCardCode = function(event) {
            $(event.target).numpad({
                type: 'alphabetical',
                target: $scope.checkGiftCard,
                textClear: $filter('translate')('Clear'),
                textCancel: $filter('translate')('Cancel')
            });
        };

        $scope.enterPhoneNumber = function(event) {
            $(event.target).numpad({
                type: 'numerical',
                textClear: $filter('translate')('Clear'),
                textCancel: $filter('translate')('Cancel')
            });
        };

        function setCustomer(customer) {
            _.findWhere($scope.fields, {name: 'customer'}).value = customer;
            setPaymentMethods();
        }

        function setCashier(cashierId) {
            $rootScope.waitFor(['cashregisters']).then(function() {
                var cashier = _.findWhere($rootScope.cashregisters, {id: cashierId});
                if (cashier && cashier.opened && cashier.selfcheckout) {
                    _.findWhere($scope.fields, {name: 'cashier'}).value = cashier;
                    setPaymentMethods();
                } else {
                    $location.path('/checkout');
                }
            });
        }
        setCashier(Number($routeParams.cashierId));

        $scope.$watch($scope.getCustomer, function(customer) {
            if (customer) {
                startTimer();
            } else {
                cancelTimer();
            }
        });

        $scope.$watch($scope.getMethod, function(method) {
           if (method && method.id !== 'swish' && !$scope.getCustomer()) {
               _.findWhere($scope.fields, {name: 'phone'}).value = undefined;
           }
        });

        live.subscribe({
            type: 'selfcheckout',
            scope: $scope,
            callback: function(data) {
                if ($scope.getCashier() && data.cardreader_id == $scope.getCashier().cardreader_id) {
                    var member = $rootScope.getMember(data.member_id);
                    if (member) {
                        setCustomer(member);
                    }
                }
            }
        });

        // Restart the timer when clicking anywhere on the screen
        $('#selfcheckout').on('mousedown', function() {
            if ($scope.getCustomer()) {
                startTimer();
            }
        });

        var recalc = $scope.recalculateBasket;
        $scope.recalculateBasket = function() {
            recalc();
            startTimer();
        };

        var reset = $scope.reset;
        $scope.reset = function() {
            reset();
            setPaymentMethods();
            $('.nmpd-wrapper').fadeOut('fast', function() { this.remove(); });
        };
    });
}]);

checkout.controller('SwishCtrl', ['$scope', '$timeout', 'server', 'options', function($scope, $timeout, server, options) {
    $scope.swishInstructions = options.selfCheckout ? 'SWISH_INSTRUCTIONS_CUSTOMER' : 'SWISH_INSTRUCTIONS';
    $scope.loadingStatus = { loading: false };

    var checkStatus = function() {
        server.get('/api/payment/transaction/get', {transaction_id: options.transaction_id}).then(function(data) {
            $scope.paid = Date.newFull(data.paid);
            $scope.failed = Date.newFull(data.failed);
            $scope.ccufail = data.ccufail;

            if (!$scope.paid && !$scope.failed) {
                $timeout(checkStatus, 1000);
            } else if(options.autoclose) {
                $timeout($scope.$close, options.autoclose === true? 0 : options.autoclose);
            }
        });
    };

    var cancelSwishPayment = function() {
        $scope.loadingStatus.loading = true;
        server.post('/api/payment/swish/cancel', { transaction_id: options.transaction_id }).then(() => {
            $scope.loadingStatus.loading = false;
            $scope.$dismiss({ notoast: true });
        });
    };

    checkStatus();

    $scope.close = function() {
        if ($scope.failed) {
            $scope.$dismiss();
        } else if ($scope.ccufail) {
            $scope.$dismiss({type: 'ccu', bundle_id: $scope.ccufail});
        } else if ($scope.paid) {
            $scope.$close();
        } else {
            cancelSwishPayment();
        }
    };
}]);

checkout.controller('CheckoutExternalCtrl', ['$scope', 'server', 'formatter', 'options', function($scope, server, formatter, options) {
    $scope.amount = formatter.format('price', options.amount);
    $scope.method = options.method;
    $scope.purchase = options.purchase;
    $scope.loadingStatus = {};
    $scope.completePurchase = function(success) {
        $scope.loadingStatus.loading = true;
        server.post('/api/checkout/external', null, {transaction_id: options.transaction_id, success: success}).then(function(result) {
            if (success && result.success) {
                $scope.$close();
            } else {
                $scope.$dismiss(result.data);
            }
            $scope.loadingStatus.loading = false;
        });
    };
}]);

checkout.factory('cashiers', ['$rootScope', '$q', '$modal', '$filter', 'formatter', 'server', function ($rootScope, $q, $modal, $filter, formatter, server) {
    var cashiers = {};
    var transfer = null;

    cashiers.close = function(cashier) {
        var message = $filter('translate')('CLOSECASHIERSHORT').format(formatter.format('price', cashier.cash));
        var modalInstance = $modal.open({
            templateUrl: 'views/closingchangeamount.html',
            controller: 'ClosingAmountCtrl',
            resolve: {
                amount: function() { return cashier.cash; },
                message: function() { return message; },
                registerCoins: function() { return cashier.registercoins; }

            }
        });

        modalInstance.result.then(function(resp) {

            function closeRegister() {
                var diff = null;
                if (resp.diff) {
                    diff = { amount: resp.diff, comment: resp.comment || '' };
                }
                server.post('/api/checkout/cashier/close', diff, {id: cashier.id}).then(function() {
                    $rootScope.cachedCashRegister = null;
                });
            }

            if (resp.diff || resp.withdrawAmount) {
                var amount = Number(cashier.cash) + (resp.diff || 0) - (resp.withdrawAmount || 0);
                server.post('/api/checkout/cashier/cash/set', null, { id: cashier.id, cash: amount }).then(closeRegister);
            }
            else { closeRegister(); }

        });
    };

    cashiers.transferPayments = function(payments) {
        transfer = {payments: payments};
    };

    cashiers.transferInvoice = function(payment) {
        transfer = {invoice: payment};
    };

    cashiers.transfer = function(what) {
        transfer = what;
    };

    cashiers.getTransfer = function() {
        return transfer;
    };

    cashiers.getChangeAmount = function(initial, option) {
        return $modal.open({templateUrl: 'views/changeamount.html', controller: 'AmountCtrl', resolve: { amount: function() { return initial; }, option: function() { return option;} }  }).result;
    };

    return cashiers;
}]);

checkout.controller('GetCashierCtrl', ['$rootScope', '$scope', '$modal', '$filter', '$location', 'server', 'options', 'cashiers', '$q', function($rootScope, $scope, $modal, $filter, $location, server, options, cashiers, $q) {

    function canSelect(c) {
        if (!options.open) {
            return true;
        }

        return c.canopen;
    }

    var selectCashier = function(c) {
        if (!canSelect(c)) {
            return;
        }

        if (options.open && !c.opened) {
            var closePromise = $q.defer();

            var cancelWatch = $rootScope.$watch(function() {
                return c.opened;
            }, function(opened) {
                if(opened) {
                    cancelWatch();
                    closePromise.resolve();
                    $rootScope.cachedCashRegister = c;
                    $scope.$close(c);
                }
            });

            var openCashier = function(amount) {
                cancelWatch();
                server.post('/api/checkout/cashier/open', null, {id: c.id, cash: amount}, 'Cashier opened', 'Failed to open cashier').then(function(result) {
                    if (result.success) {
                        if (c.selfcheckout) {
                            $scope.$close(c);
                        } else {
                            $rootScope.cachedCashRegister = c;
                            $scope.$close(c);
                        }
                    }
                });
            };

            if (c.selfcheckout) {
                openCashier();
            } else {
               cashiers.getChangeAmount(c.cash, {
                closePromise: closePromise.promise,
                registerCoins: c.registercoins
                }).then(function (amount) {
                    openCashier(amount);
                });
            }

        } else {
            $scope.$close(c);
        }
    };

    $scope.tableConfig = {
        tableLimit: 5,
        tableNumPages: 5,
        triggers: ['cashier'],
        getItems: function() {
            return $rootScope.cashregisters;
        },
        itemFilter: function(cr) {
            return !options.site || cr.site == options.site;
        },
        rowClick: selectCashier,
        columns: [
            { field: 'name', title: 'Name' },
            { field: 'selfcheckout', title: 'Type', getValue: function(c) { return $filter('translate')(c.selfcheckout ? 'Self checkout' : 'Checkout'); } },
            { field: 'opened', title: 'Opened', format: 'time' }
        ],
        buttons: [
            { title: 'Choose', onClick: selectCashier, visible: canSelect }
        ],
        hideSearchCount: true
    };
}]);

checkout.controller('CheckoutLogCtrl', ['$rootScope', '$scope', '$filter', 'server', function($rootScope, $scope, $filter, server) {
    $scope.loadingStatus = {};
    var cashiers;
    var log;

    $scope.fields = [
        {name: 'fromDate', title: 'From', required: true, type: 'date', value: Date.today() },
        {name: 'toDate', title: 'To', required: true, type: 'date', value: Date.today() },
        {name: 'cashier', title: 'Cashier', required: false, type: 'cashier'}
    ];
    $scope.getButtonText = function() {
        return 'Get log';
    };

    /*var getText = function(x) {
        if (x.type == 'open') {
            'Cashier {0} was opened with {1} in change'
        } else if (x.type == 'close') {

        }
    };*/

    var log;
    var getLog = function() {
        if ($scope.loadingStatus.loading) {
            return;
        }
        $scope.loadingStatus.loading = true;
        var fromDate = _.findWhere($scope.fields, {name: 'fromDate'}).value.yyyymmdd();
        var toDate = _.findWhere($scope.fields, {name: 'toDate'}).value.yyyymmdd();
        var cashier = _.findWhere($scope.fields, {name: 'cashier'}).value;
        var args = {fromDate: fromDate, toDate: toDate };
        if (cashier) {
            args.cashregister = cashier.id;
        }

        server.get('/api/checkout/log/get', args).then(function(data) {
            angular.forEach(data, function(row) {
                row.time = Date.newFull(row.time);
                row.cashier = _.findWhere(cashiers, {id: row.cashregister_id });
                var staff = $rootScope.getStaff(row.staff && row.staff.id);
                if (staff) {
                    row.staff = staff;
                } else {
                    if (row.staff) {
                        if (row.staff.id == 1) {
                            row.staff.name = 'Admin';
                        } else {
                            row.staff.name = row.staff.firstname ? (row.staff.firstname + " " + row.staff.lastname) : row.staff.lastname;
                        }
                    } else {
                        row.staff = $filter('translate')('Anonymous');
                    }
                }
                //row.text = getText(row.data);
            });
            log = data;
            $scope.loadingStatus.loading = false;
        });
    };

    var getCashiers = function() {
        server.get('/api/checkout/cashier/get').then(function(data) {
            angular.forEach(data, function(c) {
                c.opened = Date.newFull(c.opened);
            });
            cashiers = data;

            getLog();
        });
    };
    getCashiers();

    $scope.config = {
        getItems: function() {
            return log;
        },
        countSuffix: function() {
            return $filter('translate')('rows');
        },
        columns: [
            { field: 'time', title: 'Time', format: 'datetime' },
            { field: 'cashier.name', title: 'Cashier' },
            { field: 'data.staff.name', title: 'Staff' },
            //{ field: 'text', title: 'Event' }
            { field: 'data', title: 'Event data', format: 'json' }
        ]
    };

    $scope.submit = function() {
        getLog();
    };
}]);

checkout.controller('EnterValuesCtrl', ['$scope', 'registerCoins', function($scope, registerCoins) {

    $scope.displayCoins = registerCoins || false;

    function generateValueObjects(values) {
        var objList = [];
        for (var i = 0; i < values.length; i++) {
            objList.push({ value: values[i], amount: 0 });
        }
        return objList;
    }
    $scope.billValues = generateValueObjects([1000, 500, 200, 100, 50, 20]);
    $scope.coinValues = generateValueObjects([10, 5, 2, 1]);

    $scope.sumAmounts = function() {
        var billList = angular.copy($scope.billValues) || [];
        var coinList = angular.copy($scope.coinValues) || [];

        function valueTimesAmount(item) {
            item = item || {};
            item.value = item.value || 0;
            item.amount = item.amount || 0;
            var result = parseInt(item.value) * parseInt(item.amount);
            return result ? result : 0;
        }

        var total = 0;
        angular.forEach(billList, function(item) {
            total += valueTimesAmount(item);
        });

        angular.forEach(coinList, function(item) {
            total += valueTimesAmount(item);
        });

        $scope.amount = total;
    };

    $scope.onInputValueChange = function() {
        $scope.sumAmounts();
    };

    $scope.updateInput = function(rowObj, amount) {
        if (rowObj.amount + amount < 0) {
            rowObj.amount = 0;
        }
        else {
            rowObj.amount += amount;
            $scope.onInputValueChange();
        }
    };

}]);

checkout.controller('AmountCtrl', ['$rootScope', '$scope', '$controller', '$filter', 'server', 'amount', 'option',
    function($rootScope, $scope, $controller, $filter, server, amount, option) {
    $controller('EnterValuesCtrl', {$scope: $scope, registerCoins: option.registerCoins});

    $scope.amount = Number(amount);

    option = option || {};
    if(option.closePromise) {
        option.closePromise.then($scope.$dismiss);
    }

    $scope.disabled = function() {
        return option.disabled && option.disabled($scope.amount);
    };

}]);

checkout.controller('ClosingAmountCtrl', ['$scope', '$controller', '$filter', 'formatter', 'amount', 'message', 'registerCoins',
    function($scope, $controller, $filter, formatter, amount, message, registerCoins) {
    $controller('EnterValuesCtrl', {$scope: $scope, registerCoins: registerCoins});

    $scope.amount = $scope.initial = Number(amount);
    $scope.withdrawAmount = 0;
    $scope.message = message;
    $scope.amountDiffComment = {};

    $scope.calculateDiff = function() {
        $scope.diff = $scope.amount - $scope.initial;

        if ($scope.diff) {
            $scope.diffText = $filter('translate')('It\'s a difference of {0}, please enter a comment')
                .format(formatter.format('price', $scope.diff));
        }

        // Make sure withdrawamount is not larger than the actual amount of money available
        if ($scope.withdrawAmount > $scope.amount) {
            $scope.withdrawAmount = $scope.amount;
        }

    };
    $scope.calculateDiff($scope.amount);

    // Override template function
    $scope.onInputValueChange = function() {
        $scope.sumAmounts();
        $scope.calculateDiff();
    };

    $scope.close = function() {
        var response = {};

        if ($scope.diff) {
            response.diff = $scope.diff;
            response.comment = $scope.amountDiffComment.text || '';
        }

        if ($scope.withdrawAmount) {
            response.withdrawAmount = $scope.withdrawAmount;
        }

        $scope.$close(response);
    };

}]);

checkout.controller('CCUFailCtrl', ['$rootScope', '$scope', '$controller', '$modal', '$filter', 'server', 'pubsub',
function($rootScope, $scope, $controller, $modal, $filter, server, pubsub) {
    $controller('EconomyCtrl', {$scope: $scope});

    $scope.openDialogBundle = null;

    var createCashInvoice = function(payment, preventToClose) {
        var modal = {
            templateUrl: 'views/cashinvoice.html',
            controller: 'CashInvoiceCtrl',
            resolve: {
                options: function() {
                    return {
                        payment: payment,
                        preventToClose: preventToClose
                    };
                }
            }
        };
        if(preventToClose) {
            modal.backdrop = 'static';
            modal.keyboard = false;
        }
        $modal.open(modal);
    };

    var showDialogForBundle = function() {
        var payments = $scope.ccuFails.filter(function(p) {
            var bundle_id = p.attempts[p.attempts.length-1].bundle_id;
            return bundle_id == $scope.openDialogBundle;
        });
        if (payments.length == 1) {
            createCashInvoice(payments[0], true);
            $scope.openDialogBundle = null;
        }
    };

    var getCCUFails = function() {
        server.get('/api/payment/ccufail/get').then(function(payments) {
            $rootScope.waitFor(['members', 'staffs', 'sites']).then(function() {
                angular.forEach(payments, function(payment) {
                    $rootScope.transformPayment(payment);
                    payment.site = $rootScope.getSite(payment.site_id);
                });
                $scope.ccuFails = $scope.bundleTogether(payments, true);

                if ($scope.openDialogBundle) {
                    showDialogForBundle();
                }
            });
        });
    };

    var getPaidDate = function(payment) {
        var attempts = payment.attempts;
        if (attempts.length && payment.status == 'paid') {
            return attempts[attempts.length-1].created.yyyymmdd();
        }
    };



    $scope.ccuFailConfig = {
        getItems: function() {
            return $scope.ccuFails;
        },
        itemFilter: p => !p.site_id || p.site_id == $rootScope.selectedSite.id,
        countSuffixList: ['payment', 'payments'],
        rowClick: createCashInvoice,
        columns: [
            {field: 'date', title: 'Date', format: 'date', getValue: getPaidDate },
            {field: 'site.name', title: 'Site' },
            {field: 'name', title: 'Payment item', getValue: $scope.getProductName },
            {field: 'totalamount', title: 'Amount', format: 'price' },
            {field: 'payer.name', title: 'Customer' }
        ],
        buttons: [
            {title: 'Create cash invoice', onClick: createCashInvoice }
        ]
    };

    getCCUFails();

    $scope.pubsub('selectedSite', getCCUFails);

    var removeServerChange = $rootScope.$on('serverChange', function (event, message) {
        if (message.type == 'ccufail') {
            getCCUFails();
        }
    });

    var removeCcuTrigger = $rootScope.$on('ccufail', function (event, bundle_id) {
        $scope.openDialogBundle = bundle_id;
        getCCUFails();
    });

    $scope.$on('$destroy', function () {
        removeServerChange();
        removeCcuTrigger();
    });
}]);

checkout.controller('CashInvoiceCtrl', ['$rootScope', '$scope', '$controller', 'server', 'alertProvider', 'options',
function($rootScope, $scope, $controller, server, alertProvider, options) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.preventToClose = options.preventToClose;
    $scope.title = 'Create cash invoice';
    $scope.postUrl = '/api/payment/ccufail/createcashinvoice';

    $scope.fields = [
        {name: 'customer', title: 'Customer', required: true, type: 'customer'},
        {name: 'firstname', title: 'First name', required: true, type: 'text'},
        {name: 'lastname', title: 'Last name', required: true, type: 'text'},
        // FIXME: Company... ?
        {name: 'personalCodeNumber', title: 'Personal code number', required: false, type: 'personalCodeNumber', ptype: 'member' },
        {name: 'mail', title: 'E-mail', required: true, type: 'email', ptype: 'member'},
        {name: 'address', title: 'Address', required: true, type: 'textarea'},
        {name: 'zipCode', title: 'Zip code', required: true, type: 'text'},
        {name: 'city', title: 'City', required: true, type: 'text'}
    ];

    $scope.getCustomer = function() {
        return _.findWhere($scope.fields, {name: 'customer'}).value;
    };

    $scope.$watch($scope.getCustomer, function(customer) {
        var props = ['firstname', 'lastname', 'personalCodeNumber', 'mail', 'address', 'zipCode', 'city'];
        angular.forEach(props, function(prop) {
            _.findWhere($scope.fields, {name: prop}).value = customer && customer[prop];
        });
        $scope.fields.find(x => x.name == 'personalCodeNumber').original = customer && customer.personalCodeNumber;
    }, true);

    var createCashInvoice = function(payer_id, bundle_id) {
        server.post($scope.postUrl, null, {payer_id: payer_id, bundle_id: bundle_id }, 'Cash invoice created', 'Failed to create cash invoice').then(function(result) {
            $scope.loadingStatus.loading = false;
            if (result.success) {
                $scope.$close(true);
            }
        });
    };

    $scope.submit = function() {
        $scope.loadingStatus.loading = true;
        var item = $scope.getSubmitItem();
        var customer = item.customer;
        delete item.customer;
        item.id = customer;

        var bundle_id = options.payment.attempts[options.payment.attempts.length-1].bundle_id;

        var hasMember = $rootScope.getMember(customer);
        if (hasMember) {
            server.post('/api/member/change', item, null).then(function(result) {
                if (result.success) {
                    createCashInvoice(customer, bundle_id);
                } else {
                    alertProvider.show('error', 'Failed to create cash invoice');
                    $scope.loadingStatus.loading = false;
                }
            });
        } else {
            server.post('/api/member/add', item, null).then(function(result) {
                if (result.success) {
                    createCashInvoice(result.data.id, bundle_id);
                } else {
                    alertProvider.show('error', 'Failed to create cash invoice');
                    $scope.loadingStatus.loading = false;
                }
            });
        }
    };

    $scope.setInitialValues = function() {
        _.findWhere($scope.fields, {name: 'customer'}).value = options.payment.payer;
    };

    $scope.setInitialValues();
}]);

checkout.controller('CashRegisterChangeModalCtrl', ['$rootScope', '$scope', '$controller', '$filter', 'paymentMethods', 'cashregister', 'server', function($rootScope, $scope, $controller, $filter, paymentMethods, cashregister, server) {
    $controller('ChangeModalCtrl', {$scope: $scope});

    $scope.item = cashregister;
    $scope.postUrl = '/api/checkout/cashregister/change';

    $scope.titleSuffix = function() {
        return $scope.item.name;
    };

    var boolCounter = 0;

    const handlerTypes = [{id: 'bambora', name: 'Bambora'}];
    if ($rootScope.hasModule('Adyen')) handlerTypes.push({id: 'adyen', name: 'Zoezi Pay'});
    if ($rootScope.isTestSystem && $rootScope.currentStaff.superUser) handlerTypes.push({id: 'fake-bambora', name: 'Fake Bambora'});

    var terminalVersion = [{id: 'old', name: 'Bambora legacy'}, {id: 'new', name: 'Bambora Lane 3000'}, {'id': 'inverted', name: 'Bambora Move 5000'}];
    var terminalPrinter = [
        {id: 0, name: 'Default'},
        {id: 1, name: 'Don\'t use printer'},
        {id: 2, name: 'Use printer'},
        {id: 3, name: 'Use external printer'}
    ];
    function showBamboraFields() {
        return _.findWhere($scope.fields, {name: 'terminal_handler'}).value?.id == 'bambora';
    }
    function showAdyenFields() {
        if (!$rootScope.hasModule('Adyen')) return false;
        return _.findWhere($scope.fields, {name: 'terminal_handler'}).value?.id == 'adyen';
    }

    function getLegalEntityIdForCashRegister() {
        const siteField = $scope.fields.find(f => f.name == 'site_id');
        if (siteField?.value) {
            return siteField.value.legal_entity_id;
        }

        // Fallback to current site of the cash register
        const site = $rootScope.sites.find(s => s.id == $scope.item.site_id);
        return site ? site.legal_entity_id : null;
    }

    var terminals = null;
    function loadTerminals() {
        return new Promise((resolve, reject) => {
            const legal_entity_id = getLegalEntityIdForCashRegister();
            const url = `/api/adyen/terminal/list?legal_entity_id=${legal_entity_id}`;
            server.get(url).then(result => {
                terminals = result.map(t => {
                    let name = t.name
                    if (t.last_activity) name += ` [${t.last_activity}]`
                    return {id: t.id, name};
                });
                let tid = $scope.item.terminal_id;
                if (tid) {
                    if (!terminals.some(t => t.id == tid)) {
                        terminals.push({
                            id: tid,
                            name: `No available terminal ${tid}`
                        });
                    }
                }
                resolve();
            }).catch(reject);
        });
    }

    function onChangeHandler() {
        let adyen = showAdyenFields();
        if (adyen && terminals === null) {
            terminals = [];
            loadTerminals();
        }
    }

    function paymentMethodsFilter(pm) {
        const terminalHandler = _.findWhere($scope.fields, {name: 'terminal_handler'}).value?.id;
        if (terminalHandler == 'adyen' && pm.id == 'xcard') return false;
        if (terminalHandler == 'bambora' && pm.id == 'adyen-terminal') return false;
        return true;
    }

    function getSiteOptionsForCashRegister() {
        const site = $rootScope.sites.find(s => s.id == $scope.item.site_id);
        const sitesForLegalEntity = site ? $rootScope.sites.filter(s => s.legal_entity_id == site.legal_entity_id) : [];
        return sitesForLegalEntity;
    }

    $scope.fields = [
        {name: 'regnr', title: 'Id', type: 'label' },
        {name: 'checkouttype', title: 'Type', type: 'label', readonly: true, getValue: function() { return $filter('translate')($scope.item.selfcheckout ? 'Self checkout' : 'Checkout'); } },
        {name: 'selfcheckout', title: 'Self checkout', type: 'checkbox', change: function() { boolCounter += 1; $scope.item.selfcheckout = _.findWhere($scope.fields, {name: 'selfcheckout'}).value; } , changed: function() { return !(boolCounter % 2 == 0); }},
        {name: 'memberpage', title: 'Can check in from member page', type: 'checkbox', visible: function() { return $scope.item.selfcheckout; } },
        {name: 'name', title: 'Name', type: 'text', required: true },
        {name: 'site_id', title: 'Site', type: 'select', options: getSiteOptionsForCashRegister, required: true, change: loadTerminals, visible: function() { return $rootScope.hasModule('MultiSite'); }, useId: true },
        {name: 'autoclose', title: 'Close at midnight', type: 'checkbox' },
        {name: 'require_barcode', title: 'Require barcode for gift card', type: 'checkbox' },
        {name: 'ccufail', title: 'Simulate CCU/TCS fail', type: 'checkbox', visible: function() { return $rootScope.currentStaff.superUser; } },
        {name: 'printer_id', title: 'Printer', type: 'select', options: function() { return $rootScope.printers; }, useId: true },
        {name: 'cardreader_id', title: 'Kortläsare', required: false, type: 'select', options: function() { return $rootScope.staffs;}, optionsFilter: function(s) { return s.active && s.type == 'resource' && s.resourceType == 'door';}, visible: function() { return $scope.item.selfcheckout; }, useId: true },
        {name: 'method', title: 'Default payment method', type: 'paymentmethod', options: {checkout: true, filter: paymentMethodsFilter}, useId: true, getValuesFunc: paymentMethods.getAll, visible: function() { return !$scope.item.selfcheckout; } },
        {name: 'can_change_price', title: 'Possible for staff to change product price', type: 'checkbox', visible: function() { return !$scope.item.selfcheckout; } },
        {name: 'registercoins', title: 'Register coins at checkout opening and closing', type: 'checkbox', visible: function() { return !$scope.item.selfcheckout; } },
        {name: 'ips', title: 'Restrict access to IP', type: 'text' },

        {name: 'terminal_handler', title: 'Terminal type', type: 'select', useId: true, options: () => handlerTypes, required: false, change: onChangeHandler },

        // Bambora
        {name: 'terminal_ip', title: 'Terminal ip', type: 'text', required: false, visible: showBamboraFields },
        {name: 'terminal_port', title: 'Terminal port', type: 'text', required: false, visible: showBamboraFields },
        {name: 'terminal_net', title: 'Terminal net', type: 'text', required: false, visible: showBamboraFields },
        {name: 'terminal_version', title: 'Terminal version', type: 'select', useId: true, options: function(){ return terminalVersion; }, required: false, visible: showBamboraFields },
        {name: 'terminal_printer', title: 'Terminal printer', type: 'select', useId: true, options: function(){ return terminalPrinter; }, required: false, visible: showBamboraFields },
        {name: 'terminal_fail', title: 'Simulate fail', type: 'checkbox', visible: () => _.findWhere($scope.fields, {name: 'terminal_handler'}).value?.id == 'fake-bambora'},

        // Adyen
        {name: 'terminal_id', title: 'Terminal', type: 'select', useId: true, options: function(){ return terminals; }, required: false, visible: showAdyenFields },
        {name: 'adyen_use_printer', title: 'Print receipt', type: 'checkbox', visible: showAdyenFields },
        {name: 'adyen_terminal_receipt', title: 'Print cardholder copy', type: 'checkbox', visible: showAdyenFields },
        {name: 'terminal_tipping', title: 'Ask for tip', type: 'checkbox', visible: showAdyenFields }
    ];

    if ($scope.item.terminal_handler == 'adyen') {
        loadTerminals().then(() => {
            $scope.setValues($scope.item);
        });
    } else {
        $scope.setValues($scope.item);
    }
}]);

checkout.controller('SettingsCheckoutCtrl', ['$rootScope', '$scope', '$controller', '$modal', 'paymentMethods', 'server', 'confirm', function($rootScope, $scope, $controller, $modal, paymentMethods, server, confirm) {
    $controller('AddCtrl', {$scope: $scope});

    //$scope.title = "Add cash register";
    $scope.postUrl = '/api/checkout/cashregister/add';
    $scope.tab = 'list'; // add, list, category
    $scope.data = {
        showInvisible: true
    };

    $scope.setTab = function(name) {
        $scope.tab = name;
    };

    var isSelfCheckout = function() {
        return _.findWhere($scope.fields, {name: 'selfcheckout'}).value;
    };

    $scope.fields = [
        {name: 'regnr', title: 'Id', type: 'text', required: true },
        {name: 'name', title: 'Name', type: 'text', required: true },
        {name: 'site_id', title: 'Site', type: 'select', options: function() { return $rootScope.sites; }, required: true, visible: function() { return $rootScope.hasModule('MultiSite'); }, useId: true },
        {name: 'selfcheckout', title: 'Self checkout', type: 'checkbox' },
        {name: 'memberpage', title: 'Can check in from member page', type: 'checkbox', visible: isSelfCheckout },
        {name: 'autoclose', title: 'Close at midnight', type: 'checkbox', value: true },
        {name: 'ccufail', title: 'Simulate CCU/TCS fail', type: 'checkbox', visible: function() { return $rootScope.currentStaff.superUser; } },
        {name: 'printer_id', title: 'Printer', type: 'select', options: function() { return $rootScope.printers; }, useId: true },
        {name: 'cardreader_id', title: 'Kortläsare', required: false, type: 'select', visible: isSelfCheckout, options: function() { return $rootScope.staffs;}, optionsFilter: function(s) { return s.active && s.type == 'resource' && s.resourceType == 'door';}, useId: true },
        {name: 'method', title: 'Default payment method', type: 'paymentmethod', options: {checkout: true}, useId: true, getValuesFunc: paymentMethods.getAll, visible: function() { return !isSelfCheckout(); } },
        {name: 'ips', title: 'Restrict access to IP', type: 'text' }
    ];

    var change = function(cashregister) {
        $modal.open({
            templateUrl: 'views/changemodal.html',
            controller: 'CashRegisterChangeModalCtrl',
            resolve: {
                cashregister: function() {
                    return cashregister;
                }
            }
        });
    };

    var remove = function(cashregister) {
        confirm.show('Remove', {ladda: true}).then(function(resolve) {
            server.post('/api/checkout/cashregister/remove', null, {id: cashregister.id}, 'Cash register removed', 'Failed to remove cash register').then(function() {
                resolve();
                $rootScope.cachedCashRegister = null;
            });
        });
    };

    $scope.cashregisterConfig = {
        getItems: function() {
            return $rootScope.cashregisters;
        },
        triggers: ['cashregister'],
        rowClick: change,
        hideSearch: true,
        columns: [
            {field: 'regnr', title: 'Id'},
            {field: 'name', title: 'Name'},
            {field: 'site.name', title: 'Site', visible: function() { return $rootScope.hasModule('MultiSite'); } }
        ],
        buttons: [
            {title: 'Change', onClick: change },
            {title: 'Remove', buttonClass: 'btn-danger', onClick: remove, visible: function() { return $rootScope.currentStaff.superUser; }}
        ]
    };

}]);

checkout.controller('SettingsProductCategoryCtrl', ['$scope', 'server', 'fileManager', 'alertProvider', 'util', function($scope, server, fileManager, alertProvider, util) {

    $scope.initCategoryElement = function(el) {
        var categories = [];

        function getResult() {
            var result = [];
            var order = 1;
            el.querySelectorAll('li').forEach(function(li) {
                var span = li.childNodes[0].childNodes[1];
                var category = _.findWhere(categories, {id: li.catId});
                result.push({
                    id: li.catId,
                    name: span.textContent || span.innerText,
                    parent_id: li.parentNode.parentNode.catId || null,
                    imagekey: category.imagekey,
                    removed: category.removed,
                    order: order++
                });
            });
            return result;
        }

        function makeHash(list) {
            return list.map(function(d) {
                return d.id + ',' + d.name + ',' + d.parent_id + ',' + d.imagekey + ',' + d.removed + ',' + d.order;
            }).join(',');
        }

        var originalHash;
        $scope.categoryChanged = false;
        function checkChanges() {
            var changed = originalHash !== makeHash(getResult());
            if($scope.categoryChanged !== changed) {
                $scope.categoryChanged = changed;
                if(!$scope.$$phase) {$scope.$digest();}
            }
        }

        function getChildren(pid) {
            return categories.filter(function(cat) {
                return cat.parent_id == pid;
            }).sort(function(a, b) {
                if(a.order < b.order) {return -1;}
                if(a.order > b.order) {return 1;}
                return 0;
            });
        }

        function nn(nodeName, className) {
            var el = document.createElement(nodeName);
            if(className) {
                el.className = className;
            }
            return el;
        }

        function makeItem(cat) {
            var li = nn('li');
            var div = nn('div');
            var img = $('<img style="height: 17px;" />')[0];
            if(cat.imagekey) {
                img.src = fileManager.fileLinkByKey(cat.imagekey, 17);
            }
            var span0 = $('<span contenteditable="true" style="padding: 3px;">' + cat.name + '</span>')[0];
            var hideButton = nn('span', 'glyphicon glyphicon-eye-close pull-right item-button');
            var imageButton = nn('span', 'glyphicon glyphicon-picture pull-right item-button');
            var editButton = nn('span', 'glyphicon glyphicon-pencil pull-right item-button');

            function removeStatus(removed) {
                if(removed) {
                    hideButton.className = 'glyphicon glyphicon-eye-close pull-right item-button';
                    li.className = 'sortable-invisible';
                } else {
                    hideButton.className = 'glyphicon glyphicon-eye-open pull-right item-button';
                    li.className = '';
                }
            }

            removeStatus(cat.removed);

            [img, span0, hideButton, imageButton, editButton].forEach(function(e) {
                div.appendChild(e);
            });

            li.catId = cat.id;
            li.appendChild(div);

            div.addEventListener('click', function() {
                span0.focus();
                setTimeout(function() {
                    var range = document.createRange();
                    var sel = window.getSelection();
                    range.setStart(span0.childNodes[0], span0.textContent.length);
                    range.collapse(true);
                    sel.removeAllRanges();
                    sel.addRange(range);
                }, 0);
            });
            span0.addEventListener('keydown', function(e) {
                if(e.keyCode === 13 || e.keyCode === 27) {
                    e.preventDefault();
                    e.stopPropagation();
                    span0.blur();
                }
            });
            span0.addEventListener('blur', function() {
                checkChanges();
            });

            hideButton.addEventListener('mousedown', function(e) {e.preventDefault();e.stopPropagation();});
            imageButton.addEventListener('mousedown', function(e) {e.preventDefault();e.stopPropagation();});
            editButton.addEventListener('mousedown', function(e) {e.preventDefault();e.stopPropagation();});

            hideButton.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                cat.removed = !cat.removed;
                removeStatus(cat.removed);
                checkChanges();
            });

            imageButton.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                fileManager.chooseFile({
                    //originId: 1,
                    originType: 'product_category',
                    mimeType: 'image/*',
                    squareThumbnail: true
                }).then(function(file) {
                    cat.imagekey = file.key;
                    img.src = fileManager.fileLinkByKey(cat.imagekey, 17);
                    checkChanges();
                });

            });

            return li;
        }

        function buildChildren(pid) {
            var list = [];
            getChildren(pid).forEach(function(cat) {
                var li = makeItem(cat);
                list.push(li);
                var children = buildChildren(cat.id);
                if(children.length) {
                    var ol = document.createElement('ol');
                    li.appendChild(ol);
                    children.forEach(function(e) {
                        ol.appendChild(e);
                    });
                }
            });
            return list;
        }

        function reloadCategories(initUI) {
            server.post2('/api/trainingcard/category/get').then(function(result) {
                categories = result;

                el.innerHTML = '';
                buildChildren(null).forEach(function(e) {
                    el.appendChild(e);
                });

                if(initUI) {
                    $(el).nestedSortable({
                        forcePlaceholderSize: true,
                        handle: 'div',
                        helper: 'clone',
                        items: 'li',
                        opacity: 0.6,
                        placeholder: 'placeholder',
                        revert: 250,
                        tabSize: 25,
                        tolerance: 'pointer',
                        toleranceElement: '> div',
                        maxLevels: 30,

                        isTree: true,
                        expandOnHover: 700,
                        startCollapsed: true,

                        update: checkChanges
                    });

                    /*$('.disclose').on('click', function() {
                        $(this).closest('li').toggleClass('mjs-nestedSortable-collapsed').toggleClass('mjs-nestedSortable-expanded');
                    });*/
                }
                originalHash = makeHash(getResult());
                $scope.categoryChanged = false;
            });
        }

        reloadCategories(true);

        $scope.saveCategory = function() {
            $scope.loading = true;
            server.post2('/api/trainingcard/category/save', {
                categories: getResult()
            }).then(function() {
                $scope.loading = false;
                alertProvider.show('success', 'Settings saved');
                reloadCategories(false);
            }, function() {
                $scope.loading = false;
                alertProvider.show('error', 'Failed to save settings');
            });
        };

        var index = 1;
        $scope.addCategory = function() {
            var cat = {
                id: 'n' + index++,
                name: util.escapeHtml($scope.data.newCategory),
                imagekey: null
            };
            categories.push(cat);
            var li = makeItem(cat);
            //el.appendChild(li);
            el.insertBefore(li, el.firstChild);

            $scope.data.newCategory = '';
            $scope.categoryChanged = true;
        };

        $scope.showInvisible = function(show) {
            if(show) {
                $(el).removeClass("hide-invisible");
            } else {
                $(el).addClass("hide-invisible");
            }
        };
    };
}]);

checkout.controller('CheckoutConfirmModalCtrl', ['$scope', 'options', function($scope, options) {
    $scope.options = options;
    $scope.titleSuffix = options.title;
    $scope.content = options.content;
    $scope.cashHelpAmount = options.cashHelpAmount;
}]);

checkout.controller('GiftCardModalCtrl', ['$rootScope', '$scope', '$filter', 'server', function($rootScope, $scope, $filter, server) {
    $scope.loadingStatus = {};
    $scope.check = function(code) {
        $scope.loadingStatus.loading = true;
        var legal_entity_id = $rootScope.selectedSite ? $rootScope.selectedSite.legal_entity_id : null;
        server.get('/api/public/giftcard/verify', {code: code, allow_barcode: true, legal_entity_id: legal_entity_id}).then(function(result) {
            if (result.found && result.card && Number(result.card.amount) > 0 && !result.expired && result.paid && !result.wrong_legal_entity) {
                var giftcard = {id: result.card.id, product_id: result.card.cardtype_id, amount: result.card.amount, percentage: result.card.percentage, type: result.type, name: result.card.name, code: result.card ? result.card.code : null };
                $scope.codeError = null;
                $scope.$close(giftcard);
            } else {
                $scope.codeError = result;
            }

            $scope.loadingStatus.loading = false;
        });
    };

    $scope.getGiftCardExpire = function(codeError) {
        return $filter('translate')('The gift card expired on {0} and is no longer valid.').format(codeError.expired);
    };
}]);

checkout.controller('DiscountModalCtrl', ['$rootScope', '$scope', '$filter', 'server', 'customer', function($rootScope, $scope, $filter, server, customer) {
    $scope.loadingStatus = {};
    $scope.data = {};

    $scope.addDiscountCode = function(code) {
        $scope.loadingStatus.loading = true;

        function verifyLegacyDiscount() {
            server.get('/api/public/discount/verify', {code: code}).then(function(result) {
                if (result.found && !result.expired) {
                    $scope.codeError = null;
                    var discount = _.findWhere($rootScope.trainingcardtypes, {id: result.cardtype_id });
                    $scope.$close( {discount: discount } );
                } else {
                    $scope.codeError = result;
                }
                $scope.loadingStatus.loading = false;
            });
        }

        if (!$rootScope.hasFlag || !$rootScope.hasFlag('flag-price-rule-engine')) {
            verifyLegacyDiscount();
            return;
        }

        var customerId = customer && customer.id;
        var verifyParams = {code: code};
        if (customerId) verifyParams.customer_id = customerId;
        server.get('/api/public/pricerule/verify_code', verifyParams).then(function(prResult) {
            if (prResult.valid) {
                $scope.codeError = null;
                $scope.$close({price_rule_code: code, rule: prResult.rule});
                $scope.loadingStatus.loading = false;
            } else {
                verifyLegacyDiscount();
            }
        });
    };

    function dateValid(d) {
        let f = Date.newFull(d.validFromDate);
        let t = Date.newFull(d.validToDate);
        return f && f.isPastDate(true) && (!t || t.isFutureDate(true));
    }

    function getAny() {
        var discounts = $rootScope.trainingcardtypes.filter(function(d) { return d.discount && d.payWhatYouWant && dateValid(d);} );
        return discounts.length >= 1 ? discounts[0] : null;
    }

    $scope.getDiscounts = function() {
        return $rootScope.trainingcardtypes.filter(function(d) { return d.active && d.discount && !d.payWhatYouWant && dateValid(d);} );
    };

    $scope.hasAny = function() {
        return !!getAny();
    };

    $scope.addDiscountAmount = function(amount) {
        $scope.$close( {discount: getAny(), amount: amount } );
    };

    $scope.getDiscountExpire = function(codeError) {
        return $filter('translate')('The discount code expired on {0} and is no longer valid.').format(codeError.expired);
    };

    $scope.addDiscount = function(discount) {
        $scope.$close( {discount: discount } );
    };

    $scope.fieldsValid = function() {
        if (!$scope.data.amount && !$scope.data.code) {
            return false;
        }
        if ($scope.data.amount && $scope.data.code) {
            return false;
        }

        return true;
    };

    $scope.submit = function() {
        if ($scope.data.code) {
            $scope.addDiscountCode($scope.data.code);
        } else if ($scope.data.amount) {
            $scope.addDiscountAmount($scope.data.amount);
        }
    };
}]);
